import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import {
  faAngleDown,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faCalendar,
  faChild,
  faClock,
  faClose,
  faEnvelope, faEnvelopeOpen,
  faFaceSmile,
  faLocationDot,
  faLongArrowRight,
  faMinus,
  faPersonWalkingLuggage,
  faPlane,
  faPlaneArrival,
  faPlaneDeparture,
  faPlus,
  faRightLeft,
  faUser,
  faWifiStrong
} from '@fortawesome/free-solid-svg-icons';
import ArrayStore from 'devextreme/data/array_store';
import DataSource from 'devextreme/data/data_source';
import { merge, Observable, of } from 'rxjs';
import { ActiveModifySearch, BookingBasicProperties, ChildAgeProps, FlightSearchAirlineCodes, FlightSearchAirports, FlightSearchBaseData, FlightSearchDestinationProperties, FlightSearchHistory, FlightSearchProperties, FlightSearchRights, InfantAgeProps, OtherFlightDetailsNames } from '../Models/FlightSearchProperties';
import { FaretypeFilters, FilterFlightResultBinding, FlightSchedulesNew, FlightSearchNewResponseProperties, StopFlightFilters, flightsectorIndex, MulticityResponseFlightsNew, TimeListFilter, FilterByAirlineProperties, AirSegmentsDetailsNew, BySectorBrands, BrandsNew, RBDBaggageSelection, RBDPaneltyCharges, RBDChargeSelection, FareRulesNew, FareChangedProperties } from '../Models/flight-results-response-properties';
import { FlightSearchService } from '../Services/FlightSearch.service';
import { MessageService } from 'primeng/api';
import { DatePipe } from '@angular/common';
import { BsDatepickerConfig, BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';
import { FlightResultAdditionalProcess } from './flight-result-filters-process';
import { GetFlightResultsService } from '../Services/get-flight-results.service';
import { EmailItineraryProperties } from '../Models/ERPProperties';
import { AgencyMasterProperties } from '../Models/AgencyMasterProperties';
import { EmailItineraryService } from '../Services/emailItinerary.service';
import { ChangeRBDParamsGalileo, SelectRBD } from '../Models/FlightSearchResponseProperties';
import { BookingTimerService } from '../Services/booking-timer.service';
import { error } from 'console';
import { AgencyService } from '../Services/Agency.service';
import { environment } from '../../environments/environment';

//declare var $;
@Component({
  selector: 'app-flight-results',
  templateUrl: './flight-results-new.component.html',
  styleUrls: ['./flight-results-new.component.css'],
  providers: [BsDatepickerConfig, BsDaterangepickerConfig]
})


export class FlightResultsNewComponent {
  flightresultadditionalProcessts = new FlightResultAdditionalProcess();
  faplane = faPlane;
  faArrowRightToCity = faLongArrowRight;
  faLocationDot = faLocationDot;
  faPlaneDeparture = faPlaneDeparture;
  faPlaneArrival = faPlaneArrival;
  faMinus = faMinus;
  faplus = faPlus;
  faRightLeft = faRightLeft;
  faPlus = faPlus;
  Close = faClose;
  PersonIcon = faUser;
  faChild = faChild;
  FaceSmile = faFaceSmile;
  adultDropdowndiv: boolean = false;
  faArrowUp = faArrowUp;
  faEnvelope = faEnvelope;
  faEnvelopeOpen = faEnvelopeOpen;
  faArrowDown = faArrowDown;
  faAngleDown = faAngleDown;
  faCalendar = faCalendar;
  PersonWalking = faPersonWalkingLuggage;
  faArrowRight = faArrowRight;
  faArrowLeft = faArrowLeft;
  faClock = faClock;
  screenHeight: number;
  screenWidth: number;
  dropdownadult = false;
  dropdowneconomy = false;
  dropdownfaretype = false;
  loaderSending: boolean = false;
  childAge: boolean = false;
  InfantAge: boolean = false;
  dateCalenderShow: number = 3;
  rangeDates: Date[] | undefined;
  childList: Number[] = [];
  infantList: Number[] = [];
  filteredAirportsOW: string[] = [];
  // childAgeListOfR: ChildAgeProps[] = [];
  // infantAgeListOfR: InfantAgeProps[] = [];
  airportList: FlightSearchAirports[] = [];
  childAgeItemR: number = 0;
  childAgeValueR: number;
  childAgeListOf: ChildAgeProps[] = [];
  infantAgeListOf: InfantAgeProps[] = [];
  childAgeItem: number = 0;
  priceOfBrand: number = 0;
  childAgeValue: number=2;
  finalcountofpassengers: number = 1;
  infantAgeValue: string;
  currentIndex: number = 0;
  infantAgeValueR: string;
  Adulttravlers: boolean = true;
  IMPORTRights: boolean = false;
  AllTravelers: boolean = false;
  modifymultishow: boolean = false;
  modifyorignalshow: boolean = true;
  minDate: Date;
  maxDate: Date;
  haveRights: boolean = false;
  allBaseData$ = new FlightSearchBaseData();
  airlineList$: Observable<FlightSearchAirlineCodes[]>;
  childAgeObj = new ChildAgeProps();
  dataSource: any;
  infantAgeObj = new InfantAgeProps();
  airLineData: FlightSearchAirlineCodes[] = [];
  modifysearchObj = new FlightSearchProperties();
  onewaymodifysearchObj = new FlightSearchProperties();
  roundmodifysearchObj = new FlightSearchProperties();
  multicitymodifysearchObj = new FlightSearchProperties();
  sentToBacksearchObj = new FlightSearchProperties();
  AgencyData = new AgencyMasterProperties();
  ingredient: boolean = false;
  dataFormSubmitoneway: boolean = false;
  flightDetailsopen: boolean[] = [false];
  brandDetailsopen: boolean[] = [false];
  brandCombinationDetailsopen: boolean[] = [false];
  farerulesopen: boolean[] = [false];
  emailpopupopen: boolean = false;
  sliderAirlineShow: boolean = true
  emailpopupValidateCheck: boolean = false;
  emailpopupFlightIndex: number = 0;
  baggagedetailsopen: boolean[] = [false];
  changebookingdetailsopen: boolean[] = [false];
  searchObj = new FlightSearchProperties();
  selectedDiv: number | null = null;
  emailObj = new EmailItineraryProperties();
  flighResultObj = new FlightSearchNewResponseProperties();
  activesearch: number = 0;
  initialsearch: number = 0;
  flightsBindList: FlightSchedulesNew[] = [];
  displayedFlights: FlightSchedulesNew[] = [];
  batchSize: number = 50;
  startIndex: number = 0;
  popoverArray: boolean[] = [];
  filtersBinding = new FilterFlightResultBinding();
  currencyForShow: string = "";
  oneWayResults: boolean = false;
  roundTripResults: boolean = false;
  multicityResults: boolean = false;
  checkpanelcollapsed: boolean = false;
  //mobile declareation start here 
  mobilepopupmodifysearch: boolean = false;
  grossPrice: string;
  minValueSliderFilter: number = 0;
  maxValueSliderFilter: number = 0;
  tooltip: any;
  flightsectorIndexlist: flightsectorIndex[] = [];
  flightrequestCounter: number;
  flightresponseCounter: number;
  flightshortCountSkelton: number[] = [];
  flightsloading: boolean;
  flightsBeforeLoad: boolean;
  progressValue: number;
  totalDirectFlights: number = 0;
  totalOneStopFlights: number = 0;
  totalTwoPlusStopFlights: number = 0;
  totalRefundableFlights: number = 0;
  totalNonRefundableFlights: number = 0;
  //group ticket
  flightSearchRightsObj = new FlightSearchRights();
  noflightavailable: boolean = false;
  multibranderrormessage: boolean = false;
  previousmarkup: number = 0;
  rbdflightData = new FlightSearchNewResponseProperties();
  grossTotal: number = 0;
  rbdBaggage: RBDBaggageSelection[] = [];
  penaltyCharge: RBDPaneltyCharges[] = [];
  rbdCharg: RBDChargeSelection[] = [];
  changeBookingerror: boolean = false;
  farerulesopenbrandView: boolean = false;
  brandFareRulesObj = new FareRulesNew();
  faWifiIcon = faWifiStrong;
  isOffline: boolean = false;
  fareChanged = new FareChangedProperties();
  isFareChanged: boolean = false;
  brandsChanged: boolean = false;
    fareChangedPopUp: boolean[]=[false];
  constructor(private bookingTimerService: BookingTimerService, private emailService: EmailItineraryService,
    private router: Router, private flightService: FlightSearchService, private getFlightResultService: GetFlightResultsService,
    private messageService: MessageService, private agencyService: AgencyService) {
  }
  @ViewChild('slider', { static: false }) slider: ElementRef<HTMLElement>;
  @ViewChild('slide', { static: false }) slide: ElementRef<HTMLElement>;
  ngOnInit() {
    try {
      this.checkConnection();
      window.addEventListener('online', () => this.checkConnection());
      window.addEventListener('offline', () => this.checkConnection());
      this.flightsBeforeLoad = true;
      const groupdata = localStorage.getItem('flightSearchRightsObj');
      if (groupdata) {
        this.flightSearchRightsObj = JSON.parse(groupdata);
      }

     
 
      this.currencyForShow = localStorage.getItem("AgencyCurrency");
      const flightSearchData = localStorage.getItem('flightSearchData');

      if (!flightSearchData) {
        this.flightsBeforeLoad = false;
        this.router.navigateByUrl("/flightSearch");
        return;
      }
      this.displayedFlights = [];
      this.searchObj = JSON.parse(flightSearchData);
 
      this.initialsearch = this.searchObj.journeyType;
      this.finalcountofpassengers = this.searchObj.adult + this.searchObj.child + this.searchObj.infant;
      if (this.searchObj.child > 0 || this.searchObj.infant > 0) {
        this.AllTravelers = true;
        this.Adulttravlers = false;
      }
      this.filtersBinding.airlinesList = [];
      this.filtersBinding.fareType = new FaretypeFilters();
      this.filtersBinding.timeList = new TimeListFilter();
      this.filtersBinding.stopsDetails = new StopFlightFilters();
      this.filtersBinding.stopsDetailsReturn = new StopFlightFilters();
      this.filtersBinding.stopsDetails = new StopFlightFilters();
      this.tooltip = {
        enabled: true,
        showMode: 'always',
        position: 'top',
      };
    }
    catch (e) {

    }

    this.showtoggleflighttypeDiv(this.searchObj.journeyType);
    this.GetSearchBaseData();
    this.DateMinMaxMulti();
    this.searchReadyToBack(true);
    this.GetAgencyMasterForPrint();
  }
  ngOnDestroy() {
    localStorage.removeItem('flightSearchData');
    localStorage.removeItem('flightSearchRightsObj');
  }
  /*
  ------------------------------------------------------------------------------------------------------------------------------------------
  -----------------------------------------------------Modify Search Work Start Here--------------------------------------------------------
  ------------------------------------------------------------------------------------------------------------------------------------------
  */
  cabinClassList = [
    { cabinItem: "Economy" },
    { cabinItem: "Business" },
    { cabinItem: "Premium Economy" },
    { cabinItem: "First" },
    /*{ cabinItem: "PremiumEconomy" },*/
  ];
  childAgeList = [
    { childAgeItem: 2 },
    { childAgeItem: 3 },
    { childAgeItem: 4 },
    { childAgeItem: 5 },
    { childAgeItem: 6 },
    { childAgeItem: 7 },
    { childAgeItem: 8 },
    { childAgeItem: 9 },
    { childAgeItem: 10 },
    { childAgeItem: 11 }
  ];
  infantAgeList = [
    { infantAgeItem: "less than 1" },
    { infantAgeItem: "1" }
  ];
  fareTypeList = [
    { fareItem: "Low Fares" },
    { fareItem: "Refundable" },
    { fareItem: "Non-Refundable" },
  ];
  Dropdownadults() {
    if (this.adultDropdowndiv) {
      this.adultDropdowndiv = false;
    } else {
      this.adultDropdowndiv = true;
    }
    this.dropdownfaretype = false;
    this.dropdowneconomy = false;
  }
  GetSearchBaseData() {
    try {
      this.flightService.CheckFlightSearchScreenRights(localStorage.getItem("UserId"), localStorage.getItem("AgencyId")).subscribe((data1) => {
        this.haveRights = data1;
        this.flightService.GetFlightBaseData().subscribe((data) => {
          this.allBaseData$ = data;
          /* this.originalAirlines = this.allBaseData$.airlines;*/
          this.airlineList$ = of(this.allBaseData$.airlines);


          this.airLineData = this.allBaseData$.airlines;
          this.airportList = this.allBaseData$.airports;


          this.dataSource = new DataSource({
            store: new ArrayStore({
              data: this.airportList,
              key: "airportName"
            }),
            group: "cityCountry",

          });
          this.flightService.CheckImportRights(localStorage.getItem("UserId"), localStorage.getItem("AgencyId")).subscribe((data2) => {
            this.IMPORTRights = data2;
          })
          this.dataSource.load();

          // this.tbOnewayFromAuto.instance.focus();
          //}
        })
      })
    }
    catch (e) {

    }
  }
  filterAirportsOW(event: any) {
    let filteredOW: string[] = [];
    let query = event.query.toLowerCase();
    for (let i = 0; i < this.airportList.length; i++) {
      let airportOW = this.airportList[i];
      if (airportOW.iatA_CODE.toLowerCase().startsWith(query) || airportOW.city.toLowerCase().startsWith(query)) {
        if (airportOW.iatA_CODE.toLowerCase() === query) {
          filteredOW[0] = airportOW.airportName;
        }
        filteredOW.push(airportOW.airportName);
      }
    }
    filteredOW = [...new Set(filteredOW)];
    this.filteredAirportsOW = filteredOW;
  }
  decrementCount() {
    if (this.modifysearchObj.adult > 0) {


      this.modifysearchObj.infant = 0;
      this.infantAgeListOf.length = 0;


      this.modifysearchObj.adult--;
      if (this.modifysearchObj.adult < 1) {
        let one = document.getElementById("minusAdult") as HTMLButtonElement;
        one.style.color = "#00000063";
      }
      if (this.modifysearchObj.adult <= 9) {
        let one = document.getElementById("plusAdult") as HTMLButtonElement;
        one.style.color = "var(--first-color-second)";
      }

    }
  }
  incrementCount() {


    this.infantAgeListOf.length = 0;
    if (this.modifysearchObj.adult < 9) {

      this.modifysearchObj.adult++;
      if (this.modifysearchObj.adult > 0) {
        let one = document.getElementById("minusAdult") as HTMLButtonElement;
        one.style.color = "var(--first-color-second)";


      }

      if (this.modifysearchObj.adult == 9) {
        let one = document.getElementById("plusAdult") as HTMLButtonElement;
        one.style.color = "#00000063";
      }

      if (this.modifysearchObj.adult + this.modifysearchObj.child > 9) {
        this.childAgeListOf.length = 0;
      }
      if (this.modifysearchObj.adult + this.modifysearchObj.child == 9) {

      }

      this.ChangeOnewayAdult(this.modifysearchObj.adult);
    }


  }
  ChangeOnewayAdult(value: number) {
    try {
      let count = 9 - value;
      if (count >= 0) {
        this.childList = [];
        if ((value + this.modifysearchObj.child) > 9) {
          this.modifysearchObj.child = this.childList.length;
          this.ChangeChildAge(this.modifysearchObj.child);
        };
        for (let i = 0; i <= count; i++) {
          let childItme = new Number();
          childItme = Number(i);
          this.childList.push(childItme);
        }


      }
      else {
        for (let i = 0; i <= 9; i++) {
          let childItme = new Number();
          childItme = Number(i);
          this.childList.push(childItme);
        }
      }

      if (value > 0) {
        this.infantList = [];
        this.modifysearchObj.infant = 0;
        for (let i = 0; i < value + 1; i++) {
          let infantItem = new Number();
          infantItem = Number(i);
          this.infantList.push(infantItem);
        }
        this.ChangeOnewayInfantAge(this.modifysearchObj.infant);
      }
      else if (value == null || value == undefined) {
        this.modifysearchObj.infant = 0;
        this.infantList = [0];
        this.ChangeOnewayInfantAge(this.modifysearchObj.infant);
      }

      else {
        for (let i = 0; i <= 1; i++) {
          let infantItem = new Number();
          infantItem = Number(i);
          this.infantList.push(infantItem);
        }
      }
    }
    catch (e) {
    }
  }
  incrementcountChild() {
    if (this.modifysearchObj.child + this.modifysearchObj.adult < 9) {
      this.modifysearchObj.child++;

      this.AddNewchildAge();
      this.ChangeChildAge(this.modifysearchObj.child);



    }

  }
  AddNewchildAge() {
    this.ChangeChildAge(this.modifysearchObj.child);
    if (this.modifysearchObj.child || this.modifysearchObj.infant > 9) {
      this.childAge = true;

      let one = document.getElementById("minusChild") as HTMLButtonElement;
      one.style.color = "var(--first-color-second)";


    }


    else {
      this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'Maximunm 9 Passengers can be added..!' });

    }
  }
  decrementcountChild() {
    if (this.modifysearchObj.child > 0) {
      this.modifysearchObj.child--;

      if (this.modifysearchObj.child == 0) {
        this.childAge = false;
        let one = document.getElementById("minusChild") as HTMLButtonElement;
        one.style.color = "#00000063";
      }
      let indexToRemove = 0;
      this.RemoveChild(indexToRemove);
    }
  }
  RemoveChild(i: any) {
    if (this.childAgeListOf.length > 0)
      this.childAgeListOf.splice(i, 1);
  }
  RemoveInfant(i: any) {
    if (this.infantAgeListOf.length > 0)
      this.infantAgeListOf.splice(i, 1);
  }
  ChangeChildAge(value: number) {
    try {
      if (value != 0) {




        this.childAgeListOf.splice(0, this.childAgeListOf.length);

        for (let p = 0; p < value; p++) {
          this.childAgeObj = new ChildAgeProps();
          this.childAgeObj.childAge = this.childAgeValue;
          this.childAgeListOf.push(this.childAgeObj);
        }
        var chAgeCont = document.querySelector(".child_age_container") as HTMLDivElement;
        chAgeCont.style.display = "flex";
      }
      else {
        var chAgeCont = document.querySelector(".child_age_container") as HTMLDivElement;
        chAgeCont.style.display = "none";
        this.childAgeListOf.splice(0, this.childAgeListOf.length);
      }

    }
    catch (ex) {
      ////////Console.log(ex);
    }

  }
  ChangeOnewayInfantAge(infValue: number) {
    try {
      if (infValue != 0) {




        this.infantAgeListOf.splice(0, this.infantAgeListOf.length);
        for (let p = 0; p < infValue; p++) {
          this.infantAgeObj = new InfantAgeProps();
          this.infantAgeObj.infantAge = this.infantAgeValue;
          this.infantAgeListOf.push(this.infantAgeObj);
        }
        var inAgeCont = document.querySelector(".infant_age_container") as HTMLDivElement;
        inAgeCont.style.display = "flex";
      }
      else {
        var inAgeContNo = document.querySelector(".infant_age_container") as HTMLDivElement;
        inAgeContNo.style.display = "none";
        this.infantAgeListOf.splice(0, this.infantAgeListOf.length);
      }
    }
    catch (ex) {
      ////////Console.log(ex);
    }
  }
  incrementcountInfant() {

    if (this.modifysearchObj.infant < this.modifysearchObj.adult) {
      this.modifysearchObj.infant++;
      this.AddNewInfantAge();
      this.ChangeOnewayInfantAge(this.modifysearchObj.infant);
    }
  }
  AddNewInfantAge() {
    this.ChangeOnewayInfantAge(this.modifysearchObj.infant);
    if (this.modifysearchObj.infant > 0) {
      this.InfantAge = true;
      let one = document.getElementById("minusInfant") as HTMLButtonElement;
      one.style.color = "var(--first-color-second)";


    }


    else {
      this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'Maximunm 9 Passengers can be added..!' });
    }
  }
  decrementcountInfant() {
    if (this.modifysearchObj.infant > 0) {
      this.modifysearchObj.infant--;
      if (this.modifysearchObj.infant == 0) {
        this.InfantAge = false;
        let one = document.getElementById("minusInfant") as HTMLButtonElement;
        one.style.color = "#00000063";
      }
      let InfantToRemove = 0;
      this.RemoveInfant(InfantToRemove);
    }
  }
  calculateSum() {
    this.Dropdownadults();
    this.finalcountofpassengers = this.modifysearchObj.adult + this.modifysearchObj.child + this.modifysearchObj.infant;
    if (this.modifysearchObj.adult > 0) {
      this.AllTravelers = false;
      this.Adulttravlers = true;
    }
    if (this.modifysearchObj.child > 0 || this.modifysearchObj.infant > 0) {
      this.AllTravelers = true;
      this.Adulttravlers = false;
    }
    if (this.modifysearchObj.adult == 0 && this.modifysearchObj.child == 0 && this.modifysearchObj.infant == 0) {
      this.AllTravelers = false;
      this.Adulttravlers = true;
    }
  }
  addflightmulti() {
    this.dataFormSubmitoneway = false;
    if (this.modifysearchObj.flightLocationInfo.length < 7) {
      let flight = new FlightSearchDestinationProperties();
      this.modifysearchObj.flightLocationInfo.push(flight);
    }


  }
  removeflightMulti(index) {
    if (index !== -1) {
      this.modifysearchObj.flightLocationInfo.splice(index, 1);
    }
  }
  showtoggleflighttypeDiv(divNumber: number): void {
    this.dataFormSubmitoneway = false
    if (divNumber == 1) {
      this.activesearch = ActiveModifySearch.Oneway;

    }
    else if (divNumber == 2) {
      this.activesearch = ActiveModifySearch.RoundTrip;
    }
    else if (divNumber == 3) {
      this.activesearch = ActiveModifySearch.Multicity;
    }
    this.selectedDiv = divNumber;
    if (this.searchObj.journeyType == divNumber) {
      this.modifysearchObj = JSON.parse(JSON.stringify(this.searchObj));
      this.modifysearchObj.childAges
      return;
    }
    if (this.initialsearch != divNumber) {
      this.modifysearchObj.flightLocationInfo = [];
      this.modifysearchObj.cabinClass = "Economy";
      if (divNumber == 1) {

        let flight = new FlightSearchDestinationProperties();
        this.modifysearchObj.flightLocationInfo.push(flight);
        this.modifysearchObj.journeyType = 1;
        this.activesearch = ActiveModifySearch.Oneway;

      }
      else if (divNumber == 2) {

        let flight = new FlightSearchDestinationProperties();
        this.modifysearchObj.flightLocationInfo.push(flight);
        this.modifysearchObj.journeyType = 2;
        this.activesearch = ActiveModifySearch.RoundTrip;
      }
      else if (divNumber == 3) {
        let flight = new FlightSearchDestinationProperties();
        this.modifysearchObj.flightLocationInfo.push(flight);
        let flights = new FlightSearchDestinationProperties();
        this.modifysearchObj.flightLocationInfo.push(flights);
        this.modifysearchObj.journeyType = 3;
        this.activesearch = ActiveModifySearch.Multicity;
      }
    }
    else {
      if (divNumber == 1) {
        this.modifysearchObj = JSON.parse(JSON.stringify(this.onewaymodifysearchObj));
      }
      else if (divNumber == 2) {
        this.modifysearchObj = JSON.parse(JSON.stringify(this.roundmodifysearchObj));
      }
      else if (divNumber == 3) {
        this.modifysearchObj = JSON.parse(JSON.stringify(this.multicitymodifysearchObj));
      }
    }
  }
  onselctMultiDate(f) {
    if (f != 0) {
      for (let i: number = 1; i < this.modifysearchObj.flightLocationInfo.length; i++) {
        if (this.modifysearchObj.flightLocationInfo[i].departureDate < this.modifysearchObj.flightLocationInfo[i - 1].departureDate) {
          this.dataFormSubmitoneway = true;
          return;
        }
      }
    }

  }
  returndatechange() {
    if (this.modifysearchObj.returnDate == null || this.modifysearchObj.returnDate == "" || this.modifysearchObj.returnDate == undefined) {
      return;
    }
    let dateDepartLong: Date = new Date(this.modifysearchObj.flightLocationInfo[0].departureDate);
    let returndate: Date = new Date(this.modifysearchObj.returnDate);
    const diffInMs = returndate.getTime() - dateDepartLong.getTime();
    this.modifysearchObj.days = Math.floor(diffInMs / (1000 * 60 * 60 * 24));


  }
  addDaysReturn() {


  

    let dateDepartLong: Date = new Date(this.modifysearchObj.flightLocationInfo[0].departureDate);
    dateDepartLong.setDate(dateDepartLong.getDate() + this.modifysearchObj.days);
    dateDepartLong.setHours(0);
    dateDepartLong.setMinutes(0);
    dateDepartLong.setSeconds(0);
    dateDepartLong.setMilliseconds(0);
    let datePipe: DatePipe = new DatePipe('en-US');
    this.modifysearchObj.returnDate = (datePipe.transform(dateDepartLong, "yyyy-MM-dd"));

  }

  DateMinMaxMulti() {
    let today = new Date();
    let month = today.getMonth();
    let year = today.getFullYear();

    let prevMonth = (month === 0) ? 11 : month - 1;
    let prevYear = (month === 0) ? year - 1 : year;

    let nextMonth = (month === 11) ? 0 : month + 1;
    let nextYear = (month === 11) ? year + 1 : year;

    // Set minimum date
    this.minDate = new Date();
    this.minDate.setFullYear(prevYear);
    this.minDate.setMonth(prevMonth);

    this.maxDate = new Date();
    this.maxDate.setFullYear(nextYear);
    this.maxDate.setMonth(nextMonth);
  }
  searchReadyToBack(searchfromflightSearch: boolean) {
    this.initialsearch = this.activesearch;
    if (this.activesearch == 1) {
      this.onewaymodifysearchObj = JSON.parse(JSON.stringify(this.modifysearchObj));
    }
    else if (this.activesearch == 2) {
      this.roundmodifysearchObj = JSON.parse(JSON.stringify(this.modifysearchObj));
    }
    else if (this.activesearch == 3) {
      this.multicitymodifysearchObj = JSON.parse(JSON.stringify(this.modifysearchObj));
    }
    if (searchfromflightSearch) {
      this.childAgeListOf = this.modifysearchObj.childAges.reduce(function (s, a) {
        s.push({ childAge: Number(a) });
        return s;
      }, []);
      this.infantAgeListOf = this.modifysearchObj.infantAges.reduce(function (s, a) {
        s.push({ infantAge: a });
        return s;
      }, []);
    }
    else {
      this.modifysearchObj.childAges = [];
      this.modifysearchObj.infantAges = [];
    }

    this.modifysearchObj.parentHierarchy = localStorage.getItem("ParentHierarchy") || '';
    for (let n = 0; n < this.childAgeListOf.length; n++) {
      this.modifysearchObj.childAges.push(this.childAgeListOf[n].childAge.toString());
    }
    for (let q = 0; q < this.infantAgeListOf.length; q++) {
      this.modifysearchObj.infantAges.push(this.infantAgeListOf[q].infantAge);
     
     
    }

    if (this.modifysearchObj.journeyType == 1 && this.activesearch == ActiveModifySearch.Oneway) {
      ////////Console.log(this.modifysearchObj);
      this.modifysearchObj.tripType = "single-round";
      this.onewaySearchClick();
    }
    if (this.modifysearchObj.journeyType == 2 && this.activesearch == ActiveModifySearch.RoundTrip) {
      ////////Console.log(this.modifysearchObj);
      this.modifysearchObj.tripType = "single-round";
      this.RoundtripSearchClick();
    }
    if (this.modifysearchObj.journeyType == 3 && this.activesearch == ActiveModifySearch.Multicity) {
      this.modifysearchObj.tripType = "multi";
      for (let i: number = 1; i < this.modifysearchObj.flightLocationInfo.length; i++) {
        if (this.modifysearchObj.flightLocationInfo[i].departureDate < this.modifysearchObj.flightLocationInfo[i - 1].departureDate) {
          return;
        }
      }
      this.MultiCitySearchClick();
    }
  }
  ModifySearchClick(dataform: any) {

    this.dataFormSubmitoneway = true;
    if (dataform.invalid) {
      return;
    }
    this.flightsBeforeLoad = true;
    this.searchReadyToBack(false);
  }
  /*
------------------------------------------------------------------------------------------------------------------------------------------
-----------------------------------------------------Modify Search Work End Here--------------------------------------------------------
------------------------------------------------------------------------------------------------------------------------------------------
*/



  /*
------------------------------------------------------------------------------------------------------------------------------------------
-----------------------------------------------------Slider Cards View Price Work Start Here--------------------------------------------------------
------------------------------------------------------------------------------------------------------------------------------------------
*/

  nextSlide() {
    const totalSlides = document.querySelectorAll('.slide').length;
    if (this.currentIndex < totalSlides - 5) {
      this.currentIndex++;
      this.updateSlider();
    }
  }
  prevSlide() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.updateSlider();
    }
  }
  updateSlider() {
    const sliderElement = this.slider.nativeElement;
    const slideWidth = this.slide.nativeElement.offsetWidth;
    sliderElement.style.transform = `translateX(${-this.currentIndex * slideWidth}px)`;
  }
  /*
------------------------------------------------------------------------------------------------------------------------------------------
-----------------------------------------------------Slider Cards View Price Work End Here--------------------------------------------------------
------------------------------------------------------------------------------------------------------------------------------------------
*/




  /*
------------------------------------------------------------------------------------------------------------------------------------------
-----------------------------------------------------Flight search one way round way multicity search click Work start Here--------------------------------------------------------
------------------------------------------------------------------------------------------------------------------------------------------
*/
  GetAgencyMasterForPrint() {
    this.flightService.GetAgencyForPrint(localStorage.getItem("AgencyId")).subscribe((data) => {
      this.AgencyData = data;
      //////////Console.log(this.AgencyData.agencyName);
      // ////////Console.log(this.AgencyData);
    });
  }

  openotherDetails(type: number, index: number) {
    if (this.flightsloading) {
      return;
    }
    if (OtherFlightDetailsNames.ChangeBooking == type) {
      this.changeBookingerror = false;
      this.revalidateflightavailable = false;
      this.grossTotal = 0;
      this.rbdBaggage = [];
      this.penaltyCharge = [];
      this.rbdCharg = [];
      let checkflight = false;
      if (this.displayedFlights[index].rbdSegments != null) {
        checkflight = false
        if (this.displayedFlights[index].rbdSegments.length > 0) {
          checkflight = false;
          this.changebookingdetailsopen[index] = true;
          this.displayedFlights[index].rbdSegments.map(rbds => {
            rbds.selectedRBD = "";
          });
          this.rbdflightData.flights = [];
        }
        else {
          checkflight = true;
        }
      } else {
        checkflight = true;
      }
      if (checkflight) {
        this.flightsBeforeLoad = true;
        let changeParamGallelio = new ChangeRBDParamsGalileo();
        
        changeParamGallelio.flightSearch = this.sentToBacksearchObj;
        changeParamGallelio.flightScheduleNew = this.displayedFlights[index];
        this.getFlightResultService.GetRBDsForChangeBooking(changeParamGallelio).subscribe((flight) => {
          this.flightsBeforeLoad = false;
          if (flight != null) {
            if (flight.rbdSegments != null) {
              if (flight.rbdSegments.length > 0) {

                this.changebookingdetailsopen[index] = true;
                this.displayedFlights[index].rbdSegments = flight.rbdSegments;

              }
              else {
                this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'No Change Booking is availabe on this flight' });


              }
            }
            else {
              this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'No Change Booking is availabe on this flight' });
            }
          }

          else {
            this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'No Change Booking is availabe on this flight' });
          }

        });
      }
    }
    else if (OtherFlightDetailsNames.Baggage == type) {
      if (this.initialsearch != 3) {
        if (this.displayedFlights[index].departureFlight.supplier == "SG" && false) {
          this.flightsBeforeLoad = true;
          let changerbd = new ChangeRBDParamsGalileo();
          changerbd.transactionIdentifier = this.displayedFlights[index].transactionIdentifier;
          changerbd.supplierpricingSolution = this.displayedFlights[index].supplierPricingSolution;
          changerbd.flightSearch = this.modifysearchObj;
          this.flightService.spiceBaggage(changerbd).subscribe((bagslist) => {
            this.flightsBeforeLoad = false;
            if (bagslist.length > 0) {
              this.displayedFlights[index].frontBaggageAllowance = bagslist;
              this.baggagedetailsopen[index] = true;
            }
            else {
              this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'No Baggage Availiable' });
            }
          })

        }
        else {
          if (this.displayedFlights[index].frontBaggageAllowance.length == 0) {
            this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'No Baggage Availiable' });
            return;
          }
          this.baggagedetailsopen[index] = true;
        }
      }
      else {
        if (this.displayedFlights[index].frontBaggageAllowance.length == 0) {
          this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'No Baggage Availiable' });
          return;
        }
        this.baggagedetailsopen[index] = true;
      }




    }
    else if (OtherFlightDetailsNames.FareRules == type) {
      if (this.displayedFlights[index].fareRulesAfterShowAvailiable && (this.oneWayResults || this.roundTripResults) &&
        (this.displayedFlights[index].departureFlight.supplier == "1G" || this.displayedFlights[index].departureFlight.supplier == "6E"
          || this.displayedFlights[index].departureFlight.supplier == "AI" || this.displayedFlights[index].departureFlight.supplier == "1GGDS"
          || this.displayedFlights[index].departureFlight.supplier == "1GNDC" || this.displayedFlights[index].departureFlight.supplier == "FZ" ||
          this.displayedFlights[index].departureFlight.supplier == "J9" )) {
        this.OnewayReturnFareRules(index);

      }
      else if (this.displayedFlights[index].fareRulesAfterShowAvailiable && (this.multicityResults) &&
        (this.displayedFlights[index].multiFlights[0].supplier == "1GGDS" || this.displayedFlights[index].multiFlights[0].supplier == "1GNDC"||this.displayedFlights[index].multiFlights[0].supplier == "FZ")) {
        this.OnewayReturnFareRules(index);
      }
      else {

        this.farerulesopen[index] = true;
      }

    }
    else if (OtherFlightDetailsNames.Print == type) {
      if (this.initialsearch == 1) {
        this.flightresultadditionalProcessts.printClickOneWay(this.displayedFlights[index], this.AgencyData, this.emailObj, this.emailObj.includeAllResults, this.sentToBacksearchObj,
          this.flightsBindList, this.initialsearch);
      }
      else if (this.initialsearch == 2) {
        this.flightresultadditionalProcessts.ReturnPrintClick(this.displayedFlights[index], this.AgencyData, this.emailObj, this.emailObj.includeAllResults, this.sentToBacksearchObj,
          this.flightsBindList, this.initialsearch);
      }
      else if (this.initialsearch == 3) {
        this.flightresultadditionalProcessts.printClickMulticity(this.displayedFlights[index], this.AgencyData, this.emailObj, this.emailObj.includeAllResults, this.sentToBacksearchObj,
          this.flightsBindList, this.initialsearch);
      }
    }
    else if (OtherFlightDetailsNames.Email == type) {
      this.emailpopupopen = true;
      this.emailpopupFlightIndex = index;

    }
    else if (OtherFlightDetailsNames.Brands == type) {
      this.multibranderrormessage = false;
  
      if (this.initialsearch == 1 || this.initialsearch == 2) {
        if (this.displayedFlights[index].brands == null) {
          this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'No Brands Availiable' });
          return;
        }
        if (this.displayedFlights[index].brands.length == 0) {
          this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'No Brands Availiable' });
          return;
        }
        this.displayedFlights[index].bySectorBrands = [];
        if (!this.displayedFlights[index].allBrandsForAllSectorCheck) {
          for (let f = 0; f < this.sentToBacksearchObj.flightLocationInfo.length; f++) {
            let sectorbrand = new BySectorBrands();
            sectorbrand.fromAirport = this.sentToBacksearchObj.flightLocationInfo[f].fromAirport;
            sectorbrand.toAirport = this.sentToBacksearchObj.flightLocationInfo[f].toAirport;
            if (f == 0) {
              sectorbrand.brandsList = this.displayedFlights[index].brands;
            }
            else if (f == 1) {
              sectorbrand.brandsList = this.displayedFlights[index].returnBrands;
            }

            this.displayedFlights[index].bySectorBrands.push(sectorbrand);
          }
        }
        else if (this.displayedFlights[index].allBrandsForAllSectorCheck) {
          let sectorbrand = new BySectorBrands();
          sectorbrand.fromAirport = this.sentToBacksearchObj.flightLocationInfo[0].fromAirport;
          sectorbrand.toAirport = this.sentToBacksearchObj.flightLocationInfo[this.sentToBacksearchObj.flightLocationInfo.length - 1].toAirport;
          sectorbrand.brandsList = this.displayedFlights[index].brands;
          this.displayedFlights[index].bySectorBrands.push(sectorbrand);
        }
      }
      else if (this.initialsearch == 3) {

        if (this.displayedFlights[index].allBrandsForAllSectorCheck) {
          this.displayedFlights[index].bySectorBrands = [];
          if (this.displayedFlights[index].brands == null) {
            this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'No Brands Availiable' });
            return;
          }
          if (this.displayedFlights[index].brands.length == 0) {
            this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'No Brands Availiable' });
            return;
          }
          let sectorbrand = new BySectorBrands();
          sectorbrand.fromAirport = this.sentToBacksearchObj.flightLocationInfo[0].fromAirport;
          sectorbrand.toAirport = this.sentToBacksearchObj.flightLocationInfo[this.sentToBacksearchObj.flightLocationInfo.length - 1].toAirport;
          sectorbrand.brandsList = this.displayedFlights[index].brands;
          this.displayedFlights[index].bySectorBrands.push(sectorbrand);
        }
      }
      if (this.displayedFlights[index].bySectorBrands.length > 0) {


        for (let k = 0; k < this.displayedFlights[index].bySectorBrands.length; k++) {
          this.displayedFlights[index].bySectorBrands[k].brandsindex = false;
        }
        this.flightsectorIndexlist = [];
        this.priceOfBrand = 0;
        for (let is = 0; is < this.displayedFlights[index].bySectorBrands.length; is++) {
          let flighobj = new flightsectorIndex();
          this.flightsectorIndexlist.push(flighobj);
        }
        this.displayedFlights[index].bySectorBrands[0].brandsindex = true;
        this.brandDetailsopen[index] = true;
      }
      else {
        //no brands Available
        this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'No Brands Availiable' });
      }
    }
    else if (OtherFlightDetailsNames.FlightDetails == type) {
      this.flightDetailsopen[index] = true;
    }
    else if (OtherFlightDetailsNames.CombinationBrands == type) {
      this.multibranderrormessage = false;
      if (this.displayedFlights[index].combinationOfBrands == null) {
        if (this.displayedFlights[index].combinationOfBrands.length == 0) {
          this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'No Brands Availiable' });
          return;
        }
      }
      this.flightsectorIndexlist = [];
      this.priceOfBrand = 0;
      for (let is = 0; is < this.displayedFlights[index].combinationOfBrands.length; is++) {
        let flighobj = new flightsectorIndex();
        this.flightsectorIndexlist.push(flighobj);
      }
      if (this.displayedFlights[index].combinationOfBrands.length > 0) {
        this.brandCombinationDetailsopen[index] = true;
      }
      else {
        //no brands Available
        this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'No Brands Availiable' });
      }
    }
  }
  emailClick(form: any) {
    this.emailpopupValidateCheck = true;
    if (form.invalid) {
      return;
    }
    if (this.initialsearch == 1 || this.initialsearch == 2) {
      /*      this.loaderSending = true;*/
      let emailObj: EmailItineraryProperties = this.flightresultadditionalProcessts.sendEmails(this.displayedFlights[this.emailpopupFlightIndex], this.AgencyData, this.emailObj, this.emailObj.includeAllResults, this.modifysearchObj,
        this.flightsBindList, this.initialsearch);
      if (emailObj.body == null) {
        this.loaderSending = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error While Adding Data' });
      }
      else {
        this.emailService.emailItinerary(this.emailObj).subscribe((data) => {
          this.loaderSending = false;
          if (data == true) {
            this.emailpopupopen = false;
            this.messageService.add({ severity: 'success', summary: 'Sent', detail: 'Email Successfully Sent' });


          }
          else {
            this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'Email Not Sent' });
          }

        });
      }
    }
    else if (this.initialsearch == 3) {
      this.loaderSending = true;
      let checkindex = 0;
      if (!this.emailObj.includeAllResults) {
        checkindex = this.emailpopupFlightIndex;
      }
      let emailObj: EmailItineraryProperties = this.flightresultadditionalProcessts.sendEmailMulticity1(checkindex, this.AgencyData, this.emailObj, this.emailObj.includeAllResults, this.modifysearchObj,
        this.flightsBindList, this.initialsearch);
      if (emailObj.body == null) {
        this.loaderSending = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error While Adding Data' });
      }
      else {
        this.emailService.emailItinerary(this.emailObj).subscribe((data) => {
          this.loaderSending = false;
          if (data == true) {
            this.messageService.add({ severity: 'success', summary: 'Sent', detail: 'Email Successfully Sent' });


          }
          else {
            this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'Email Not Sent' });
          }

        });
      }
    }
  }

  onewaySearchClick() {
    this.oneWayResults = true;
    this.roundTripResults = false;
    this.multicityResults = false;

    this.sentToBacksearchObj = new FlightSearchProperties();
    this.sentToBacksearchObj.parentHierarchy = localStorage.getItem("ParentHierarchy");
    this.sentToBacksearchObj = JSON.parse(JSON.stringify(this.modifysearchObj));
    let deplist = this.modifysearchObj.flightLocationInfo[0].fromAirport.split("-");
    let start = deplist[0];
    let tolist = this.modifysearchObj.flightLocationInfo[0].toAirport.split("-");
    let start1 = tolist[0];
    this.modifysearchObj.flightLocationInfo[0].fromCity = start.trim();
    this.modifysearchObj.flightLocationInfo[0].toCity = start1.trim();

    for (let i = 0; i < this.airportList.length; i++) {
      if (this.modifysearchObj.flightLocationInfo[0].fromCity.trim() == this.airportList[i].iatA_CODE) {
        this.modifysearchObj.flightLocationInfo[0].combineAirportFrom = this.airportList[i].combineAirportFrom;
        break;
      }
    }
    for (let i = 0; i < this.airportList.length; i++) {
      if (this.modifysearchObj.flightLocationInfo[0].toCity.trim() == this.airportList[i].iatA_CODE) {
        this.modifysearchObj.flightLocationInfo[0].combineAirportTo = this.airportList[i].combineAirportTo;
        break;
      }
    }
    for (let n = 0; n < this.childAgeListOf.length; n++) {
      this.sentToBacksearchObj.childAges.push(this.childAgeListOf[n].childAge.toString());
    }
    for (let q = 0; q < this.infantAgeListOf.length; q++) {
      this.sentToBacksearchObj.infantAges.push(this.infantAgeListOf[q].infantAge);
      
    }

    this.sentToBacksearchObj.agencyID = localStorage.getItem("AgencyId");
    const deptdate = new Date(this.modifysearchObj.flightLocationInfo[0].departureDate);
    this.modifysearchObj.flightLocationInfo[0].departureDate = this.formatDate(deptdate);
    this.sentToBacksearchObj.flightLocationInfo = JSON.parse(JSON.stringify(this.modifysearchObj.flightLocationInfo));

    // History
    let searchHistoryObj = new FlightSearchHistory();
    searchHistoryObj.agencyId = localStorage.getItem("AgencyId") || '';
    searchHistoryObj.userId = Number(localStorage.getItem("UserId"));
    searchHistoryObj.fromAirport = this.sentToBacksearchObj.flightLocationInfo[0].fromAirport;
    searchHistoryObj.toAirport = this.sentToBacksearchObj.flightLocationInfo[0].toAirport;
    searchHistoryObj.fromCity = this.sentToBacksearchObj.flightLocationInfo[0].fromCity;
    searchHistoryObj.toCity = this.sentToBacksearchObj.flightLocationInfo[0].toCity;
    searchHistoryObj.departureDate = String(this.sentToBacksearchObj.flightLocationInfo[0].departureDate);
    searchHistoryObj.tripType = "Oneway";
    searchHistoryObj.travelClass = this.sentToBacksearchObj.cabinClass;
    searchHistoryObj.fareType = this.sentToBacksearchObj.fareType;
    searchHistoryObj.isNonStop = this.sentToBacksearchObj.nonStopFlight;
    searchHistoryObj.isLowCost = this.sentToBacksearchObj.lowCostAirline;
    searchHistoryObj.isGDSAirline = this.sentToBacksearchObj.gdsAirline;
    searchHistoryObj.adults = this.sentToBacksearchObj.adult;
    searchHistoryObj.children = this.sentToBacksearchObj.child;
    searchHistoryObj.infants = this.sentToBacksearchObj.infant;
    searchHistoryObj.returnDate = "N/A";
    searchHistoryObj.fromAirportReturn = "N/A";
    searchHistoryObj.toAirportReturn = "N/A";
    searchHistoryObj.fromCityReturn = "N/A";
    searchHistoryObj.toCityReturn = "N/A";
    this.addFlightSearchHistory(searchHistoryObj);
    this.GetAllFlightResults();
  }
  RoundtripSearchClick() {
    try {
      this.oneWayResults = false;
      this.roundTripResults = true;
      this.multicityResults = false;
      let flightlocation = new FlightSearchDestinationProperties();
      this.sentToBacksearchObj = new FlightSearchProperties();
      this.sentToBacksearchObj = JSON.parse(JSON.stringify(this.modifysearchObj));
      this.sentToBacksearchObj.agencyID = localStorage.getItem("AgencyId");
      this.sentToBacksearchObj.parentHierarchy = localStorage.getItem("ParentHierarchy");
      const deptdate = new Date(this.modifysearchObj.flightLocationInfo[0].departureDate);
      this.modifysearchObj.flightLocationInfo[0].departureDate = this.formatDate(deptdate);
      const returndate = new Date(this.modifysearchObj.returnDate);
      this.modifysearchObj.returnDate = this.formatDate(returndate);
      flightlocation = JSON.parse(JSON.stringify(this.modifysearchObj.flightLocationInfo[0]));
      let deplist = flightlocation.fromAirport.split("-");
      let start = deplist[0];
      let tolist = flightlocation.toAirport.split("-");
      let start1 = tolist[0];
      let fligthlocationlist = FlightSearchDestinationProperties[0];
      fligthlocationlist = [];
      let flightlocation1 = new FlightSearchDestinationProperties();
      fligthlocationlist.push(flightlocation1);
      let flightlocation2 = new FlightSearchDestinationProperties();
      fligthlocationlist.push(flightlocation2);
      for (let f = 0; f < fligthlocationlist.length; f++) {
        fligthlocationlist[f] = new FlightSearchDestinationProperties();
        if (f == 0) {
          fligthlocationlist[f].fromCity = start.trim();
          fligthlocationlist[f].fromAirport = flightlocation.fromAirport;
          fligthlocationlist[f].departureDate = flightlocation.departureDate;
          fligthlocationlist[f].toAirport = flightlocation.toAirport;
          fligthlocationlist[f].toCity = start1.trim();
        }
        if (f == 1) {
          fligthlocationlist[f].fromCity = start1.trim();
          fligthlocationlist[f].fromAirport = flightlocation.toAirport;
          fligthlocationlist[f].departureDate = this.modifysearchObj.returnDate;
          fligthlocationlist[f].toAirport = flightlocation.fromAirport;
          fligthlocationlist[f].toCity = start.trim();
        }
      }
      this.sentToBacksearchObj.flightLocationInfo = JSON.parse(JSON.stringify(fligthlocationlist));

      for (let f = 0; f < this.sentToBacksearchObj.flightLocationInfo.length; f++) {
        for (let i = 0; i < this.airportList.length; i++) {
          if (this.sentToBacksearchObj.flightLocationInfo[f].fromCity.trim() == this.airportList[i].iatA_CODE) {
            this.sentToBacksearchObj.flightLocationInfo[f].combineAirportFrom = this.airportList[i].combineAirportFrom;
            break;
          }
        }
        for (let i = 0; i < this.airportList.length; i++) {
          if (this.sentToBacksearchObj.flightLocationInfo[f].toCity.trim() == this.airportList[i].iatA_CODE) {
            this.sentToBacksearchObj.flightLocationInfo[f].combineAirportTo = this.airportList[i].combineAirportTo;
            break;
          }
        }
      }
      for (let n = 0; n < this.childAgeListOf.length; n++) {
        this.sentToBacksearchObj.childAges.push(this.childAgeListOf[n].childAge.toString());
      }
      for (let q = 0; q < this.infantAgeListOf.length; q++) {
        this.sentToBacksearchObj.infantAges.push(this.infantAgeListOf[q].infantAge);
        
      }




      let searchHistoryObj = new FlightSearchHistory();
      searchHistoryObj.agencyId = localStorage.getItem("AgencyId") || '';
      searchHistoryObj.userId = Number(localStorage.getItem("UserId"));
      searchHistoryObj.fromAirport = this.sentToBacksearchObj.flightLocationInfo[0].fromAirport;
      searchHistoryObj.toAirport = this.sentToBacksearchObj.flightLocationInfo[0].toAirport;
      searchHistoryObj.fromCity = this.sentToBacksearchObj.flightLocationInfo[0].fromCity;
      searchHistoryObj.toCity = this.sentToBacksearchObj.flightLocationInfo[0].toCity;
      searchHistoryObj.departureDate = String(this.sentToBacksearchObj.flightLocationInfo[0].departureDate);
      searchHistoryObj.returnDate = String(this.sentToBacksearchObj.flightLocationInfo[this.sentToBacksearchObj.flightLocationInfo.length - 1].departureDate);
      searchHistoryObj.tripType = "Roundway";
      searchHistoryObj.travelClass = this.sentToBacksearchObj.cabinClass;
      searchHistoryObj.returnTravelClass = this.sentToBacksearchObj.cabinClassReturnTrip;
      searchHistoryObj.fareType = this.sentToBacksearchObj.fareType;
      searchHistoryObj.isNonStop = this.sentToBacksearchObj.nonStopFlight;
      searchHistoryObj.isLowCost = this.sentToBacksearchObj.lowCostAirline;
      searchHistoryObj.isGDSAirline = this.sentToBacksearchObj.gdsAirline;
      searchHistoryObj.duration = String(this.sentToBacksearchObj.days);
      searchHistoryObj.adults = this.sentToBacksearchObj.adult;
      searchHistoryObj.children = this.sentToBacksearchObj.child;
      searchHistoryObj.infants = this.sentToBacksearchObj.infant;
      searchHistoryObj.fromAirportReturn = this.sentToBacksearchObj.flightLocationInfo[0].toAirport;
      searchHistoryObj.toAirportReturn = this.sentToBacksearchObj.flightLocationInfo[0].fromAirport;
      searchHistoryObj.fromCityReturn = this.sentToBacksearchObj.flightLocationInfo[0].toCity;
      searchHistoryObj.toCityReturn = this.sentToBacksearchObj.flightLocationInfo[0].fromCity;
      this.addFlightSearchHistory(searchHistoryObj);
      this.GetAllFlightResults();
    }
    catch (e) {
      //////////Console.log(e)
    }
  }
  MultiCitySearchClick() {
    try {
      this.oneWayResults = false;
      this.roundTripResults = false;
      this.multicityResults = true;
      this.sentToBacksearchObj = new FlightSearchProperties();
      this.sentToBacksearchObj.adult = this.modifysearchObj.adult;
      this.sentToBacksearchObj.infant = this.modifysearchObj.infant;
      this.sentToBacksearchObj.parentHierarchy = localStorage.getItem("ParentHierarchy");
      this.sentToBacksearchObj.child = this.modifysearchObj.child;
      this.sentToBacksearchObj.tripType = "multi";
      this.sentToBacksearchObj.fareType = this.modifysearchObj.fareType;
      this.sentToBacksearchObj.cabinClass = this.modifysearchObj.cabinClass;
      for (let n = 0; n < this.childAgeListOf.length; n++) {
        this.sentToBacksearchObj.childAges.push(this.childAgeListOf[n].childAge.toString());
      }
      for (let q = 0; q < this.infantAgeListOf.length; q++) {
        this.sentToBacksearchObj.infantAges.push(this.infantAgeListOf[q].infantAge);
        if (this.sentToBacksearchObj.infantAges[q] == "less than 1") {
          this.sentToBacksearchObj.infantAges[q] = "0";
        }
        else if (this.modifysearchObj.infant == 0) {
          this.sentToBacksearchObj.infantAges.splice(0, this.sentToBacksearchObj.infantAges.length);
        }
      }
      this.sentToBacksearchObj.agencyID = localStorage.getItem("AgencyId");
      this.sentToBacksearchObj.flightLocationInfo = JSON.parse(JSON.stringify(this.modifysearchObj.flightLocationInfo));
      for (let i = 0; i < this.sentToBacksearchObj.flightLocationInfo.length; i++) {
        let start = this.sentToBacksearchObj.flightLocationInfo[i].fromAirport.indexOf(this.sentToBacksearchObj.flightLocationInfo[i].fromAirport[0]);
        let end = this.sentToBacksearchObj.flightLocationInfo[i].fromAirport.indexOf('-');
        this.sentToBacksearchObj.flightLocationInfo[i].fromCity = this.sentToBacksearchObj.flightLocationInfo[i].fromAirport.slice(start, end).trim();
        let start1 = this.sentToBacksearchObj.flightLocationInfo[i].toAirport.indexOf(this.sentToBacksearchObj.flightLocationInfo[i].toAirport[0]);
        let end1 = this.sentToBacksearchObj.flightLocationInfo[i].toAirport.indexOf('-');
        this.sentToBacksearchObj.flightLocationInfo[i].toCity = this.sentToBacksearchObj.flightLocationInfo[i].toAirport.slice(start, end).trim();
        const depdates = new Date(this.sentToBacksearchObj.flightLocationInfo[i].departureDate);
        this.sentToBacksearchObj.flightLocationInfo[i].departureDate = this.formatDate(depdates);
        this.sentToBacksearchObj.journeyType = 3;
        for (let j = 0; j < this.airportList.length; j++) {
          if (this.sentToBacksearchObj.flightLocationInfo[i].fromCity.trim() == this.airportList[j].iatA_CODE) {
            this.sentToBacksearchObj.flightLocationInfo[i].combineAirportFrom = this.airportList[j].combineAirportFrom;
            break;
          }
        }
        for (let k = 0; k < this.airportList.length; k++) {
          if (this.sentToBacksearchObj.flightLocationInfo[i].toCity.trim() == this.airportList[k].iatA_CODE) {
            this.sentToBacksearchObj.flightLocationInfo[i].combineAirportTo = this.airportList[k].combineAirportTo;
            break;
          }
        }
      }
      // History
      let searchHistoryObj = new FlightSearchHistory();
      searchHistoryObj.agencyId = localStorage.getItem("AgencyId");
      searchHistoryObj.userId = Number(localStorage.getItem("UserId"));
      for (let b = 0; b < this.sentToBacksearchObj.flightLocationInfo.length; b++) {
        searchHistoryObj.fromAirport += this.sentToBacksearchObj.flightLocationInfo[b].fromAirport + ", ";
        searchHistoryObj.toAirport += this.sentToBacksearchObj.flightLocationInfo[b].toAirport + ", ";
        searchHistoryObj.departureDate += this.sentToBacksearchObj.flightLocationInfo[b].departureDate + ", ";
        searchHistoryObj.fromCity += this.sentToBacksearchObj.flightLocationInfo[b].fromCity + ", ";
        searchHistoryObj.toCity += this.sentToBacksearchObj.flightLocationInfo[b].toCity + ", ";
      }
      let fromAirports = searchHistoryObj.fromAirport.trimRight();
      let toAirports = searchHistoryObj.toAirport.trimRight();
      let departureDates = searchHistoryObj.departureDate.trimRight();
      let fromCities = searchHistoryObj.fromCity.trimRight();
      let toCities = searchHistoryObj.toCity.trimRight();
      searchHistoryObj.fromAirport = fromAirports.slice(0, -1);
      searchHistoryObj.toAirport = toAirports.slice(0, -1);
      searchHistoryObj.departureDate = departureDates.slice(0, -1);
      searchHistoryObj.fromCity = fromCities.slice(0, -1);
      searchHistoryObj.toCity = toCities.slice(0, -1);
      searchHistoryObj.tripType = "Multi City";
      searchHistoryObj.travelClass = this.sentToBacksearchObj.cabinClass;
      searchHistoryObj.fareType = this.sentToBacksearchObj.fareType;
      searchHistoryObj.isNonStop = this.sentToBacksearchObj.nonStopFlight;
      searchHistoryObj.isLowCost = this.sentToBacksearchObj.lowCostAirline;
      searchHistoryObj.isGDSAirline = this.sentToBacksearchObj.gdsAirline;
      searchHistoryObj.adults = this.sentToBacksearchObj.adult;
      searchHistoryObj.children = this.sentToBacksearchObj.child;
      searchHistoryObj.infants = this.sentToBacksearchObj.infant;
      searchHistoryObj.returnDate = "N/A";
      this.addFlightSearchHistory(searchHistoryObj);
      this.GetAllFlightResults();


    }
    catch (e) {
      //////Console.log
    }
  }
  formatDate(date: Date): string {
    const year = date.getFullYear();
    const day = ('0' + date.getDate()).slice(-2);
    const month = ('0' + (date.getMonth() + 1)).slice(-2); // months are 0-based
    return `${year}-${month}-${day}`;
  }

  GetAllFlightResults() {
  
    const isValidAirline = (airline: string | undefined | null): boolean => {
      return airline !== null && airline !== undefined && airline.trim() !== "";
    };

    const getAllFlightResultsLCCS: Observable<FlightSearchNewResponseProperties>[] = [

       (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "AI" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "AI" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "AI"))
         ? this.getFlightResultService.AirIndiaFlightsResult(this.sentToBacksearchObj) : null,

       (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "G9" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "G9" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "G9" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "3L" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "3L" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "3L" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "9P" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "9P" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "9P" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "E5" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "E5" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "E5" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "3O" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "3O" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "3O"))
         ? this.getFlightResultService.GetFlightResultAirArabiaOneApiNew(this.sentToBacksearchObj) : null,

       (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "G9" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "G9" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "G9" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "3L" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "3L" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "3L" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "9P" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "9P" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "9P" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "E5" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "E5" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "E5" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "3O" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "3O" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "3O"))
         ? this.getFlightResultService.GetFlightResultAirArabiaPakistanOneApiNew(this.sentToBacksearchObj) : null,


       (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "FZ" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "FZ" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "FZ"))
         ? this.getFlightResultService.FlyDubaiFlightResultsTushmit(this.sentToBacksearchObj) : null,

       (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "FZ" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "FZ" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "FZ"))
         ? this.getFlightResultService.FlyDubaiFlightsResult(this.sentToBacksearchObj) : null,

       //(!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) &&
       //  isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "3L" ||
       //  isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "3L" ||
       //  isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "3L"))
       //  ? this.getFlightResultService.AirArabia3LFlightsResult(this.sentToBacksearchObj) : null,

       (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) &&
         isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "3L" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "3L" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "3L"))
         ? this.getFlightResultService.AirArabia3LFlightsResultPakistan(this.sentToBacksearchObj) : null,

       //(!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "G9" ||
       //  isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "G9" ||
       //  isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "G9"))
       //  ? this.getFlightResultService.AirArabiaFlightsResult(this.sentToBacksearchObj) : null,

       (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "G9" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "G9" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "G9"))
         ? this.getFlightResultService.AirArabiaFlightsResultPakistan(this.sentToBacksearchObj) : null,


       //(!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "9P" ||
       //  isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "9P" ||
       //  isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "9P"))
       //  ? this.getFlightResultService.FlyJinnahFlightsResult(this.sentToBacksearchObj) : null,

       (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "PA" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "PA" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "PA"))
         ? this.getFlightResultService.GetFlightResultAirBlue(this.sentToBacksearchObj) : null,
      (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "PA" ||
        isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "PA" ||
        isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "PA"))
        ? this.getFlightResultService.GetFlightResultAirBlueTUTravels(this.sentToBacksearchObj) : null,
       (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "PA" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "PA" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "PA"))
        ? this.getFlightResultService.GetFlightResultAirBlueT4Travels(this.sentToBacksearchObj) : null,
      (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "PA" ||
        isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "PA" ||
        isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "PA"))
        ? this.getFlightResultService.GetFlightResultAirBlueSastaTravels(this.sentToBacksearchObj) : null,

       (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "J9" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "J9" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "J9"))
         ? this.getFlightResultService.AljazeeraFlightOKAPI(this.sentToBacksearchObj) : null,

       (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "J9" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "J9" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "J9"))
         ? this.getFlightResultService.AljazeeraFlightOKAPIBSP(this.sentToBacksearchObj) : null,

       (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "J9" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "J9" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "J9"))
         ? this.getFlightResultService.AljazeeraFlightT4TRVLS(this.sentToBacksearchObj) : null,

       (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "J9" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "J9" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "J9"))
         ? this.getFlightResultService.AljazeeraFlightT4TRVLSBSP(this.sentToBacksearchObj) : null,



       (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "SG" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "SG" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "SG"))
         ? this.getFlightResultService.SpiceFlightResult(this.sentToBacksearchObj) : null,


       (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "PK" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "PK" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "PK"))
         ? this.getFlightResultService.PIAFlightsResult(this.sentToBacksearchObj) : null,

       (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "8D" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "8D" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "8D"))
         ? this.getFlightResultService.FitsAirFlightResult(this.sentToBacksearchObj) : null,

       (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "6E" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "6E" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "6E"))
         ? this.getFlightResultService.GetFlightsResult6E8X4I(this.sentToBacksearchObj) : null,

       (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "EK" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "EK" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "EK"))
         ? this.getFlightResultService.GetFlightResultEmiratesT4travels(this.sentToBacksearchObj) : null,

       (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "EK" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "EK" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "EK"))
         ? this.getFlightResultService.GetFlightResultEmiratesTUtravels(this.sentToBacksearchObj) : null,

       (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "BS" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "BS" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "BS"))
         ? this.getFlightResultService.USBanglaFlightsResult(this.sentToBacksearchObj) : null,

       (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "FT" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "FT" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "FT"))
         ? this.getFlightResultService.GetFlightSearchResultFTOktravels(this.sentToBacksearchObj) : null,

       //(!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "ER" ||
       //  isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "ER" ||
       //  isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "ER"))
       //  ? this.getFlightResultService.GetFlightResultSereneAir(this.sentToBacksearchObj) : null,

       (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "QP" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "QP" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "QP"))
         ? this.getFlightResultService.GetFlightSearchResultAkasaOkTravel(this.sentToBacksearchObj) : null,
       (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "QP" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "QP" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "QP"))
         ? this.getFlightResultService.GetFlightSearchResultOVOktravels(this.sentToBacksearchObj) : null,
       , (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "XY" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "XY" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "XY"))
         ? this.getFlightResultService.GetFlightSearchResultFlynas(this.sentToBacksearchObj) : null,

       (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "G9" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "G9" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "G9" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "3L" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "3L" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "3L" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "9P" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "9P" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "9P" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "E5" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "E5" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "E5" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "3O" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "3O" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "3O"))
         ? this.getFlightResultService.GetFlightResultAirArabiaTushmitOneApi(this.sentToBacksearchObj) : null,

      (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "PK" ||
        isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "PK" ||
        isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "PK"))
        ? this.getFlightResultService.GetPIANDCFlightSearch(this.sentToBacksearchObj) : null,

    
       (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "PF" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "PF" ||
         isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "PF"))
         ? this.getFlightResultService.GetFlightSearchResultAirSial(this.sentToBacksearchObj) : null,

      (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "TK" ||
        isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "TK" ||
        isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "TK"))
        ? this.getFlightResultService.GetTurkishAirlinesFlightSearch(this.sentToBacksearchObj) : null,


    ].filter(Boolean);
    const getAllFlightResultsGDS: Observable<FlightSearchNewResponseProperties>[] = [
       this.getFlightResultService.GetFlightsResultGDS8X4I(this.sentToBacksearchObj),
       this.getFlightResultService.GetFlightsResultNDC8X4I(this.sentToBacksearchObj),
       this.getFlightResultService.GetFlightsResultGalileoB2D(this.sentToBacksearchObj),
       this.getFlightResultService.GetFlightsResultGalileo82QT(this.sentToBacksearchObj),
       this.getFlightResultService.GetFlightsResultGalileo8K5X(this.sentToBacksearchObj),
       this.getFlightResultService.GetFlightsResultGalileo8X4I(this.sentToBacksearchObj),
       this.getFlightResultService.GetFlightsResultGalileo(this.sentToBacksearchObj),
       this.getFlightResultService.GetFlightsResultGalileo7KE2(this.sentToBacksearchObj),
       this.getFlightResultService.GetFlightsResultSabreR0AL(this.sentToBacksearchObj),
       this.getFlightResultService.GetFlightsResultGDS7KE2(this.sentToBacksearchObj),
       this.getFlightResultService.GetFlightsResultNDC7KE2(this.sentToBacksearchObj),
       this.getFlightResultService.GetFlightsResultGDS8K5X(this.sentToBacksearchObj),
       this.getFlightResultService.GetFlightsResultNDC8K5X(this.sentToBacksearchObj),
       this.getFlightResultService.GetFlightsResultGDSB2D(this.sentToBacksearchObj),
       this.getFlightResultService.GetFlightsResultNDCB2D(this.sentToBacksearchObj),
      this.getFlightResultService.GetFlightResultSharafTravel(this.sentToBacksearchObj),
      this.getFlightResultService.GetFlightsResultGalileo1WS(this.sentToBacksearchObj),
      this.getFlightResultService.GetFlightsResultGDS1WS(this.sentToBacksearchObj),
      this.getFlightResultService.GetFlightsResultNDC1WS(this.sentToBacksearchObj),

    ];

    const getAllFlightResultsGDSMulitcity: Observable<MulticityResponseFlightsNew>[] = [
      this.getFlightResultService.GetFlightsResultMultiCityGDS8X4I(this.sentToBacksearchObj),
      this.getFlightResultService.GetFlightsResultMultiCityNDC8X4I(this.sentToBacksearchObj),
      this.getFlightResultService.GetMultiFlightsResultGalileo82QT(this.sentToBacksearchObj),
      this.getFlightResultService.GetMultiFlightsResultGalileo(this.sentToBacksearchObj),
      this.getFlightResultService.GetMultiFlightsResultGalileo8X4I(this.sentToBacksearchObj),
      this.getFlightResultService.GetMultiFlightsResultGalileoB2D(this.sentToBacksearchObj),
      this.getFlightResultService.GetMultiFlightsResultGalileo8K5X(this.sentToBacksearchObj),
      this.getFlightResultService.GetMultiFlightsResultGalileo7KE2(this.sentToBacksearchObj),
      this.getFlightResultService.GetFlightsResultMultiCityGDSB2D(this.sentToBacksearchObj),
      this.getFlightResultService.GetFlightsResultMultiCityNDCB2D(this.sentToBacksearchObj),
      this.getFlightResultService.GetFlightsResultMultiCityGDS8K5X(this.sentToBacksearchObj),
      this.getFlightResultService.GetFlightsResultMultiCityGDS7KE2(this.sentToBacksearchObj),
      this.getFlightResultService.GetFlightsResultMultiCityNDC8K5X(this.sentToBacksearchObj),
      this.getFlightResultService.GetFlightsResultMultiCityNDC7KE2(this.sentToBacksearchObj),
      this.getFlightResultService.GetMultiFlightsResultSharaf(this.sentToBacksearchObj),
 

    ];
    const getAllFlightResultsLCCMulitcity: Observable<MulticityResponseFlightsNew>[] = [

      (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "3L" ||
        isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "3L" ||
        isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "3L"))
        ? this.getFlightResultService.GetFlightResultAirArabia3LMultiPakistan(this.sentToBacksearchObj) : null,

      (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "3L" ||
        isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "3L" ||
        isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "3L"))
        ? this.getFlightResultService.GetFlightResultAirArabiaMulti3L(this.sentToBacksearchObj) : null,

      (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "G9" ||
        isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "G9" ||
        isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "G9"))
        ? this.getFlightResultService.GetFlightResultAirArabiaMultiPakistan(this.sentToBacksearchObj) : null,

      (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "G9" ||
        isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "G9" ||
        isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "G9"))
        ? this.getFlightResultService.GetFlightResultAirArabiaMulti(this.sentToBacksearchObj) : null,

      (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "EK" ||
        isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "EK" ||
        isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "EK"))
        ? this.getFlightResultService.GetFlightResultEmiratesT4travelsMulti(this.sentToBacksearchObj) : null,

  
      (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "PA" ||
        isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "PA" ||
        isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "PA"))
        ? this.getFlightResultService.GetFlightResultAirBlueSastaTravelsMulti(this.sentToBacksearchObj) : null,
      (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "PA" ||
        isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "PA" ||
        isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "PA"))
        ? this.getFlightResultService.AirBlueMulticityFlightResult(this.sentToBacksearchObj) : null,
      (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "PA" ||
        isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "PA" ||
        isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "PA"))
        ? this.getFlightResultService.GetFlightResultAirBlueTUTravelsMulti(this.sentToBacksearchObj) : null,

      (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "PA" ||
        isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "PA" ||
        isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "PA"))
        ? this.getFlightResultService.AirBlueMulticityFlightResultT4Travels(this.sentToBacksearchObj) : null,

      (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "PK" ||
        isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "PK" ||
        isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "PK"))
        ? this.getFlightResultService.PIAMulticityFlightResult(this.sentToBacksearchObj) : null,

      (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "6E" ||
        isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "6E" ||
        isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "6E"))
        ? this.getFlightResultService.GetMultiFlightsResult6E8X4I(this.sentToBacksearchObj) : null,
      (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "FZ" ||
        isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "FZ" ||
        isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "FZ"))
        ? this.getFlightResultService.FlyDubaiTushmitMulticityFlightResult(this.sentToBacksearchObj) : null,

      (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "FZ" ||
        isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "FZ" ||
        isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "FZ"))
        ? this.getFlightResultService.FlyDubaiMulticityFlightResult(this.sentToBacksearchObj) : null,
      (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "XY" ||
        isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "XY" ||
        isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "XY"))
        ? this.getFlightResultService.GetMultiFlightsResultFlynas(this.sentToBacksearchObj) : null,
      (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "J9" ||
        isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "J9" ||
        isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "J9"))
        ? this.getFlightResultService.AljazeeraFlightMultiT4TRVLSBSP(this.sentToBacksearchObj) : null,

      (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "J9" ||
        isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "J9" ||
        isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "J9"))
        ? this.getFlightResultService.AljazeeraFlightMultiT4TRVLS(this.sentToBacksearchObj) : null,

      (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "J9" ||
        isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "J9" ||
        isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "J9"))
        ? this.getFlightResultService.AljazeeraFlightMultiOKAPI(this.sentToBacksearchObj) : null,

      (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "J9" ||
        isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "J9" ||
        isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "J9"))
        ? this.getFlightResultService.AljazeeraFlightMultiOKAPIBSP(this.sentToBacksearchObj) : null,
      (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "PK" ||
        isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "PK" ||
        isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "PK"))
        ? this.getFlightResultService.GetPIANDCFlightSearchMulti(this.sentToBacksearchObj) : null,

      // (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "G9" ||
      //   isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "G9" ||
      //   isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "G9" ||
      //   isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "3L" ||
      //   isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "3L" ||
      //   isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "3L" ||
      //   isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "9P" ||
      //   isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "9P" ||
      //   isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "9P" ||
      //   isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "E5" ||
      //   isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "E5" ||
      //   isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "E5" ||
      //   isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "3O" ||
      //   isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "3O" ||
      //   isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "3O"))
      //   ? this.getFlightResultService.GetMultiCityFlightResultAirArabiaOneApiNew(this.sentToBacksearchObj) : null,
      // (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "G9" ||
      //   isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "G9" ||
      //   isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "G9" ||
      //   isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "3L" ||
      //   isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "3L" ||
      //   isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "3L" ||
      //   isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "9P" ||
      //   isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "9P" ||
      //   isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "9P" ||
      //   isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "E5" ||
      //   isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "E5" ||
      //   isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "E5" ||
      //   isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "3O" ||
      //   isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "3O" ||
      //   isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "3O"))
      //   ? this.getFlightResultService.GetMultiCityFlightResultAirArabiaTushmitOneApi(this.sentToBacksearchObj) : null,
      // (!this.sentToBacksearchObj.prefferedAirlineCheck || (isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "G9" ||
      //   isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "G9" ||
      //   isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "G9" ||
      //   isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "3L" ||
      //   isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "3L" ||
      //   isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "3L" ||
      //   isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "9P" ||
      //   isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "9P" ||
      //   isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "9P" ||
      //   isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "E5" ||
      //   isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "E5" ||
      //   isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "E5" ||
      //   isValidAirline(this.sentToBacksearchObj.prefferedAirline3) && this.sentToBacksearchObj.prefferedAirline3 == "3O" ||
      //   isValidAirline(this.sentToBacksearchObj.prefferedAirline2) && this.sentToBacksearchObj.prefferedAirline2 == "3O" ||
      //   isValidAirline(this.sentToBacksearchObj.prefferedAirline1) && this.sentToBacksearchObj.prefferedAirline1 == "3O"))
      //   ? this.getFlightResultService.GetMultiCityFlightResultAirArabiaPakistanOneApiNew(this.sentToBacksearchObj) : null,
    ];




   
      this.flightsloading = true;
      this.noflightavailable = false;
      this.sliderAirlineShow = true;
      this.flightshortCountSkelton = [];
      this.flightshortCountSkelton.push(1);
      this.flightshortCountSkelton.push(2);
      this.flightshortCountSkelton.push(3);
      this.flightshortCountSkelton.push(4);
      this.batchSize = 50;
      this.startIndex = 0;
      this.flightrequestCounter = 0;
      this.flightresponseCounter = 0;
      this.flighResultObj = new FlightSearchNewResponseProperties();
      this.flighResultObj.flights = [];
      this.flightsBindList = [];
      this.displayedFlights = [];
      this.popoverArray = [];
      this.filtersBinding.airlinesList = [];
      this.filtersBinding.fareType = new FaretypeFilters();
      this.filtersBinding.timeList = new TimeListFilter();
      this.filtersBinding.stopsDetails = new StopFlightFilters();
      this.filtersBinding.stopsDetailsReturn = new StopFlightFilters();
      this.filtersBinding.stopsDetails = new StopFlightFilters();
      this.flightsBeforeLoad = false;
    if (!this.modifysearchObj.byPassSearch) {
      if (this.modifysearchObj.journeyType == 1 || this.modifysearchObj.journeyType == 2) {

        if (this.modifysearchObj.lowCostAirline == true) {
          try {
            this.flightrequestCounter += getAllFlightResultsLCCS.length;
            merge(...getAllFlightResultsLCCS).subscribe(
              result => {
                if (result != null) {
                  if (result.flights != null) {
                    if (result.flights.length > 0) {
                      if (this.sentToBacksearchObj.nonStopFlight) {
                        result.flights = result.flights.filter(
                          (z) => z.departureFlight.stopCount == 0
                        );
                      }
                      if (this.sentToBacksearchObj.fareType == "Refundable") {
                        result.flights = result.flights.filter(
                          (z) => z.departureFlight.nonRefundable == false
                        );
                      }
                      else if (this.sentToBacksearchObj.fareType == "Non-Refundable") {

                        result.flights = result.flights.filter(
                          (z) => z.departureFlight.nonRefundable == true
                        );

                      }
                      this.flighResultObj.flights = this.flighResultObj.flights.concat(result.flights);

                      this.flighResultObj.flights.forEach(flight => {
                        let totalPrice = 0;
                        ////Console.log(this.popoverArray);
                        for (let i = 0; i < flight.passengerFares.length; i++) {
                          totalPrice += Number(flight.passengerFares[i].agencyTotalPrice.substring(3));
                        }
                        this.grossPrice = flight.passengerFares[0].agencyTotalPrice.substring(0, 3) + " " + totalPrice.toFixed(2);
                        flight.departureFlight.discountedFare = totalPrice;
                      });
                      this.flightsBindList = this.flightsBindList.concat(result.flights);
                      this.loadInitialFilters();

                      for (let j = 0; j < this.flightsBindList.length; j++) {
                        this.popoverArray.push(false);
                      }
                    }
                  }
                }

                this.flightLoaderClose();
              },
              error => {
                console.error(error);
                this.flightLoaderClose();
              }
            );
          } catch (e) {
            console.error(e);
            this.flightLoaderClose();
          }
        }
        if (this.modifysearchObj.gdsAirline == true) {
          this.flightrequestCounter += getAllFlightResultsGDS.length;
          try {
            merge(...getAllFlightResultsGDS).subscribe(
              result => {
                if (result != null) {
                  if (result.flights != null) {
                    if (result.flights.length > 0) {
                      if (this.sentToBacksearchObj.nonStopFlight) {
                        result.flights = result.flights.filter(
                          (z) => z.departureFlight.stopCount == 0
                        );
                      }
                      if (this.sentToBacksearchObj.fareType == "Refundable") {
                        result.flights = result.flights.filter(
                          (z) => z.departureFlight.nonRefundable == false
                        );
                      }
                      else if (this.sentToBacksearchObj.fareType == "Non-Refundable") {

                        result.flights = result.flights.filter(
                          (z) => z.departureFlight.nonRefundable == true
                        );

                      }
                      this.flighResultObj.flights = this.flighResultObj.flights.concat(result.flights);
                      this.flighResultObj.flights.forEach(flight => {
                        let totalPrice = 0;
                        ////Console.log(this.popoverArray);
                        for (let i = 0; i < flight.passengerFares.length; i++) {
                          totalPrice += Number(flight.passengerFares[i].agencyTotalPrice.substring(3));
                        }
                        this.grossPrice = flight.passengerFares[0].agencyTotalPrice.substring(0, 3) + " " + totalPrice.toFixed(2);
                        flight.departureFlight.discountedFare = totalPrice;
                      });
                      this.flightsBindList = this.flightsBindList.concat(result.flights);
                      this.loadInitialFilters();

                      for (let j = 0; j < this.flightsBindList.length; j++) {
                        this.popoverArray.push(false);
                      }
                    }
                  }
                }

                this.flightLoaderClose();
              },
              error => {
                console.error(error);
                this.flightLoaderClose();
              }
            );
          }
          catch (e) {
            console.error(e);
            this.flightLoaderClose();
          }
        }

        if (this.flightSearchRightsObj.agencyGroupTicketSearch && this.flightSearchRightsObj.userGroupTicketSearch) {
          this.flightrequestCounter += 1;
          try {
            this.getFlightResultService.GetGroupFlightResult(this.sentToBacksearchObj).subscribe((result) => {
              if (result != null) {
                if (result.flights != null) {
                  if (result.flights.length > 0) {

                    this.flighResultObj.flights = this.flighResultObj.flights.concat(result.flights);

                    this.flighResultObj.flights.forEach(flight => {
                      let totalPrice = 0;
                      ////Console.log(this.popoverArray);
                      for (let i = 0; i < flight.passengerFares.length; i++) {
                        totalPrice += Number(flight.passengerFares[i].agencyTotalPrice.substring(3));
                      }
                      this.grossPrice = flight.passengerFares[0].agencyTotalPrice.substring(0, 3) + " " + totalPrice.toFixed(2);
                      flight.departureFlight.discountedFare = totalPrice;
                    });
                    this.flightsBindList = this.flightsBindList.concat(result.flights);
                    this.loadInitialFilters();

                    for (let j = 0; j < this.flightsBindList.length; j++) {
                      this.popoverArray.push(false);
                    }
                  }
                }
              }

              this.flightLoaderClose();
            });
          }
          catch (e) {
            console.error(e);
            this.flightLoaderClose();
          }
        }



        ////Console.log("Request", this.flightrequestCounter);
      }
      else if (this.modifysearchObj.journeyType == 3) {
        if (this.modifysearchObj.lowCostAirline == true) {
          this.flightrequestCounter += getAllFlightResultsLCCMulitcity.length;
          try {
            merge(...getAllFlightResultsLCCMulitcity).subscribe(
              result => {
                if (result != null) {
                  if (result.allMultiFlights != null) {
                    if (result.allMultiFlights.length > 0) {
                      if (this.sentToBacksearchObj.nonStopFlight) {
                        result.allMultiFlights = result.allMultiFlights.filter(
                          (z) => z.multiFlights.length > 0 && z.multiFlights[0].stopCount == 0
                        );
                      }
                      if (this.sentToBacksearchObj.fareType == "Refundable") {
                        result.allMultiFlights = result.allMultiFlights.filter(
                          (z) => z.multiFlights.length > 0 && z.multiFlights[0].nonRefundable == false
                        );
                      }
                      else if (this.sentToBacksearchObj.fareType == "Non-Refundable") {

                        result.allMultiFlights = result.allMultiFlights.filter(
                          (z) => z.multiFlights.length > 0 && z.multiFlights[0].nonRefundable == true
                        );

                      }
                      this.flighResultObj.flights = this.flighResultObj.flights.concat(result.allMultiFlights);
                      this.flighResultObj.flights.forEach(flight => {
                        let totalPrice = 0;
                        ////Console.log(this.popoverArray);
                        for (let i = 0; i < flight.passengerFares.length; i++) {
                          totalPrice += Number(flight.passengerFares[i].agencyTotalPrice.substring(3));
                        }
                        this.grossPrice = flight.passengerFares[0].agencyTotalPrice.substring(0, 3) + " " + totalPrice.toFixed(2);
                        flight.multiFlights[0].discountedFare = totalPrice;
                      });
                      this.flightsBindList = this.flightsBindList.concat(result.allMultiFlights);
                      this.loadInitialFilters();

                      for (let j = 0; j < this.flightsBindList.length; j++) {
                        this.popoverArray.push(false);
                      }
                    }
                  }
                }

                this.flightLoaderClose();
              },
              error => {
                console.error(error);
                this.flightLoaderClose();
              }
            );
          } catch (e) {
            console.error(e);
            this.flightLoaderClose();
          }
        }
        if (this.modifysearchObj.gdsAirline == true) {
          this.flightrequestCounter += getAllFlightResultsGDSMulitcity.length;
          try {
            merge(...getAllFlightResultsGDSMulitcity).subscribe(
              result => {
                if (result != null) {
                  if (result.allMultiFlights != null) {
                    if (result.allMultiFlights.length > 0) {
                      if (this.sentToBacksearchObj.nonStopFlight) {
                        result.allMultiFlights = result.allMultiFlights.filter(
                          (z) => z.multiFlights.length > 0 && z.multiFlights[0].stopCount == 0
                        );
                      }
                      if (this.sentToBacksearchObj.fareType == "Refundable") {
                        result.allMultiFlights = result.allMultiFlights.filter(
                          (z) => z.multiFlights.length > 0 && z.multiFlights[0].nonRefundable == false
                        );
                      }
                      else if (this.sentToBacksearchObj.fareType == "Non-Refundable") {

                        result.allMultiFlights = result.allMultiFlights.filter(
                          (z) => z.multiFlights.length > 0 && z.multiFlights[0].nonRefundable == true
                        );

                      }
                      this.flighResultObj.flights = this.flighResultObj.flights.concat(result.allMultiFlights);

                      this.flightsBindList = this.flightsBindList.concat(result.allMultiFlights);
                      this.loadInitialFilters();

                      for (let j = 0; j < this.flightsBindList.length; j++) {
                        this.popoverArray.push(false);
                      }
                    }
                  }
                }

                this.flightLoaderClose();
              },
              error => {
                console.error(error);
                this.flightLoaderClose();
              }
            );
          }
          catch (e) {
            console.error(e);
            this.flightLoaderClose();
          }
        }
      }
    }
    else {
      if (this.flightSearchRightsObj.agencyGroupTicketSearch && this.flightSearchRightsObj.userGroupTicketSearch) {
        this.flightrequestCounter = 1;
        try {
          this.getFlightResultService.GetGroupFlightResult(this.sentToBacksearchObj).subscribe((result) => {
            if (result != null) {
              if (result.flights != null) {
                if (result.flights.length > 0) {

                  this.flighResultObj.flights = this.flighResultObj.flights.concat(result.flights);

                  this.flightsBindList = this.flightsBindList.concat(result.flights);
                  this.loadInitialFilters();

                  for (let j = 0; j < this.flightsBindList.length; j++) {
                    this.popoverArray.push(false);
                  }
                }
              }
            }

            this.flightLoaderClose();
          });
        }
        catch (e) {
          console.error(e);
          this.flightLoaderClose();
        }
      }

    }



  }
  flightLoaderClose() {
    this.flightresponseCounter++;
    this.progressValue = (this.flightresponseCounter / this.flightrequestCounter) * 100;
    ////Console.log("Response", this.flightresponseCounter);
    if (this.flightrequestCounter == this.flightresponseCounter) {
      if (this.initialsearch != 3) {
        this.minValueSliderFilter = this.getMinPrice(this.flightsBindList, "oneround");
        this.maxValueSliderFilter = this.getMaxPrice(this.flightsBindList, "oneround");
      } else {
        this.minValueSliderFilter = this.getMinPrice(this.flightsBindList, "multi");
        this.maxValueSliderFilter = this.getMaxPrice(this.flightsBindList, "multi");

      }
      if (this.flighResultObj.flights.length > 0) {
        this.flightsloading = false;
        this.flightshortCountSkelton = [];
        this.noflightavailable = false;

      }
      else {
        this.flightsloading = false;
        this.flightshortCountSkelton = [];
        this.noflightavailable = true;
        this.sliderAirlineShow = false;
      }



    }
  }
  addFlightSearchHistory(searchHistoryObj) {
    this.flightService.flightSearchHistoryInsert(searchHistoryObj).subscribe(data => {
      ////Console.log(data);
    });
  }
  getLastAirportForAirsegment(inputString: string): string {
    const parts = inputString.split('-');
    return parts.length > 1 ? parts.slice(2).join(' ') : inputString;
  }
  OnewayReturnFareRules(flightIndex: number) {
    let gal = new ChangeRBDParamsGalileo();
    gal.brandselected = false;
    this.flightsBeforeLoad = true;
    if (this.oneWayResults == true || this.roundTripResults == true) {
      gal.flightSearch = this.sentToBacksearchObj;
      gal.flightScheduleNew = this.displayedFlights[flightIndex];
      gal.supplier = this.displayedFlights[flightIndex].departureFlight.supplier;
      gal.bookingPCC = this.displayedFlights[flightIndex].departureFlight.pcc;
      gal.fromAirport = this.displayedFlights[flightIndex].fromAirport;
      gal.toAirport = this.displayedFlights[flightIndex].toAirport;
      gal.transactionIdentifier = this.displayedFlights[flightIndex].transactionIdentifier;
      gal.supplierpricingSolution = this.displayedFlights[flightIndex].supplierPricingSolution;
      gal.passengerFares = this.displayedFlights[flightIndex].passengerFares;

      this.flightService.GetFlightFareRules(gal).subscribe((data) => {
        this.flightsBeforeLoad = false;
        if (data != null) {
          this.displayedFlights[flightIndex].fareRulesNew = data.flights[0].fareRulesNew;
          this.farerulesopen[flightIndex] = true;
        }
      });



    }
    else if (this.multicityResults) {
      gal.flightSearch = this.sentToBacksearchObj;
      gal.flightScheduleNew = this.displayedFlights[flightIndex];
      gal.supplier = this.displayedFlights[flightIndex].multiFlights[0].supplier;
      gal.bookingPCC = this.displayedFlights[flightIndex].multiFlights[0].pcc;
      gal.fromAirport = this.displayedFlights[flightIndex].fromAirport;
      gal.toAirport = this.displayedFlights[flightIndex].toAirport;
      gal.transactionIdentifier = this.displayedFlights[flightIndex].transactionIdentifier;
      gal.supplierpricingSolution = this.displayedFlights[flightIndex].supplierPricingSolution;
      gal.passengerFares = this.displayedFlights[flightIndex].passengerFares;

      this.flightService.GetFlightFareRules(gal).subscribe((data) => {
        this.flightsBeforeLoad = false;
        if (data != null) {
          this.displayedFlights[flightIndex].fareRulesNew = data.flights[0].fareRulesNew;
          this.farerulesopen[flightIndex] = true;
        }
      });
    }
  }


  /*
------------------------------------------------------------------------------------------------------------------------------------------
-----------------------------------------------------Flight search one way round way multicity search click Work End Here--------------------------------------------------------
------------------------------------------------------------------------------------------------------------------------------------------
*/


  /*
------------------------------------------------------------------------------------------------------------------------------------------
-----------------------------------------------------Flight Selection Simple Process Work Start Here--------------------------------------------------------
------------------------------------------------------------------------------------------------------------------------------------------
*/
  async SelectFlight(flightIndex: number, brands: boolean) {
    if (environment.operatingCountry === "Pakistan") {
    let userId = Number(localStorage.getItem("UserId"));

      const roleName: string = await this.agencyService
        .GetUserRoleName(userId)
        .toPromise();
      if (roleName === 'Fare Search Officer') {

        this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'You are not allowed to make a booking.' });

        return; // 🚀 whole method stops
      }
    }

    let gal = new ChangeRBDParamsGalileo();
    gal.brandselected = brands;
    this.flightsBeforeLoad = true;
    if (this.oneWayResults == true || this.roundTripResults == true) {
      gal.flightSearch = this.sentToBacksearchObj;
      gal.flightScheduleNew = this.displayedFlights[flightIndex];
      gal.supplier = this.displayedFlights[flightIndex].departureFlight.supplier;
      gal.bookingPCC = this.displayedFlights[flightIndex].departureFlight.pcc;
      gal.fromAirport = this.displayedFlights[flightIndex].fromAirport;
      gal.toAirport = this.displayedFlights[flightIndex].toAirport;
      gal.transactionIdentifier = this.displayedFlights[flightIndex].transactionIdentifier;
      gal.supplierpricingSolution = this.displayedFlights[flightIndex].supplierPricingSolution;
      gal.passengerFares = this.displayedFlights[flightIndex].passengerFares;
      if (this.isFareChanged) {
        gal.brandselected = this.brandsChanged;
        gal.isFareChanged = this.isFareChanged;
        gal.fareChanged = this.fareChanged;
      }

      this.flightService.InitialBook(gal).subscribe((data) => {
        this.flightsBeforeLoad = false;
        if (data != null) {
          if (data.flights.length > 0) {
            let requestObj = new BookingBasicProperties();
            requestObj.extraProfit = this.filtersBinding.applyMarkup;
            requestObj.fromAirport = data.flights[0].fromAirport;
            requestObj.brandsSelected = brands;
            requestObj.toAirport = data.flights[0].toAirport;
            requestObj.airportsList = this.airportList;
            requestObj.bookingPCC = data.flights[0].departureFlight.pcc;
            requestObj.airSegment = data.flights[0].airSegmentsNew;
            requestObj.flightProp = this.sentToBacksearchObj;
            requestObj.stopcount = data.flights[0].departureFlight.stopCount;
            requestObj.groupTicketId = data.flights[0].departureFlight.groupTicketId;
            requestObj.supplierCode = data.flights[0].departureFlight.supplier;
            requestObj.passengerFares = data.flights[0].passengerFares;
            requestObj.nonRefundable = data.flights[0].departureFlight.nonRefundable;
            requestObj.supplierPricingSolution = data.flights[0].supplierPricingSolution;
            requestObj.transactionIdentifierJ = data.flights[0].transactionIdentifier;
            requestObj.flightscheduleNew = data.flights[0];
            this.GetTimeAgainstSupplier(data.flights[0].departureFlight.supplier);
            sessionStorage.setItem('bkdata', JSON.stringify(requestObj));
            this.router.navigateByUrl('/passengerInfo');
          }
          else {
            if (data.isFareChanged) {
              this.brandsChanged = brands;
              this.fareChangedPopUp[flightIndex] = true;
              this.isFareChanged = data.isFareChanged;
              this.fareChanged = data.fareChanged;
            }
            else {
              if (data.error != null && data.error != undefined && data.error != "") {
                this.messageService.add({ severity: 'error', summary: 'Rejected', detail: data.error });

              }
              else {
                this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'Selected Flight Not Available.' });

              }
            }
          }
        }
      });



    }
    else if (this.multicityResults == true) {
      gal.flightSearch = this.sentToBacksearchObj;
      gal.flightScheduleNew = this.displayedFlights[flightIndex];
      gal.supplier = this.displayedFlights[flightIndex].multiFlights[0].supplier;
      gal.bookingPCC = this.displayedFlights[flightIndex].multiFlights[0].pcc;
      gal.fromAirport = this.displayedFlights[flightIndex].fromAirport;
      gal.toAirport = this.displayedFlights[flightIndex].toAirport;
      gal.transactionIdentifier = this.displayedFlights[flightIndex].transactionIdentifier;
      gal.supplierpricingSolution = this.displayedFlights[flightIndex].supplierPricingSolution;
      gal.passengerFares = this.displayedFlights[flightIndex].passengerFares;
      if (this.isFareChanged) {
        gal.brandselected = this.brandsChanged;
        gal.isFareChanged = this.isFareChanged;
        gal.fareChanged = this.fareChanged;
      }
      this.flightService.InitialBookMulti(gal).subscribe((data) => {
        this.flightsBeforeLoad = false;
        if (data!=null && data.allMultiFlights.length != 0) {
          let requestObj = new BookingBasicProperties();
          requestObj.extraProfit = this.filtersBinding.applyMarkup;
          requestObj.fromAirport = data.allMultiFlights[0].fromAirport;
          requestObj.brandsSelected = brands;
          requestObj.toAirport = data.allMultiFlights[0].toAirport;
          requestObj.airportsList = this.airportList;
          requestObj.bookingPCC = data.allMultiFlights[0].multiFlights[0].pcc;
          requestObj.airSegment = data.allMultiFlights[0].airSegmentsNew;
          requestObj.flightProp = this.sentToBacksearchObj;
          requestObj.stopcount = data.allMultiFlights[0].multiFlights[0].stopCount;
          requestObj.supplierCode = data.allMultiFlights[0].multiFlights[0].supplier;
          requestObj.passengerFares = data.allMultiFlights[0].passengerFares;
          requestObj.nonRefundable = data.allMultiFlights[0].multiFlights[0].nonRefundable;
          requestObj.supplierPricingSolution = data.allMultiFlights[0].supplierPricingSolution;
          requestObj.transactionIdentifierJ = data.allMultiFlights[0].transactionIdentifier;
          requestObj.flightscheduleNew = data.allMultiFlights[0];
          this.GetTimeAgainstSupplier(data.allMultiFlights[0].multiFlights[0].supplier);
          sessionStorage.setItem('bkdata', JSON.stringify(requestObj));
          this.router.navigateByUrl('/passengerInfo');



        } else {
          if (data.isFareChanged) {
            this.brandsChanged = brands;
            this.fareChangedPopUp[flightIndex] = true;
            this.isFareChanged = data.isFareChanged;
            this.fareChanged = data.fareChanged;
          }
          else {
            if (data.error != null && data.error != undefined && data.error != "") {
              this.messageService.add({ severity: 'error', summary: 'Rejected', detail: data.error });

            }
            else {
              this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'Selected Flight Not Available.' });

            }
          }
          //this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'Selected Flight Not Available.' });
        }
      });

    }
  }


  /*
------------------------------------------------------------------------------------------------------------------------------------------
-----------------------------------------------------Flight Selection Simple Process Work end Here--------------------------------------------------------
------------------------------------------------------------------------------------------------------------------------------------------
*/


  /*
------------------------------------------------------------------------------------------------------------------------------------------
-----------------------------------------------------Brands Selection Work Start Here--------------------------------------------------------
------------------------------------------------------------------------------------------------------------------------------------------
*/
  showNextBrand(flight, sector): boolean {
    let brands = false;
    if (this.displayedFlights[flight].bySectorBrands[sector].supplierPricingSolution != null && this.displayedFlights[flight].bySectorBrands[sector].supplierPricingSolution != "" && this.displayedFlights[flight].bySectorBrands[sector].supplierPricingSolution != undefined) {
      this.displayedFlights[flight].bySectorBrands[sector].brandsindex = false;
      this.displayedFlights[flight].bySectorBrands[sector + 1].brandsindex = true;
      this.multibranderrormessage = false;
      brands = true;

    }
    else {
      this.multibranderrormessage = true;


      brands = false;
    }
    return brands;
  }
  showPreviousBrand(flight, sector) {
    this.displayedFlights[flight].bySectorBrands[sector].brandsindex = false;
    this.displayedFlights[flight].bySectorBrands[sector - 1].brandsindex = true;
  }
  selectBrandFlight(flight, sector, brand) {
    this.multibranderrormessage = false;
    try {
      //this.flightsectorIndexlist[sector]
      if (flight == this.flightsectorIndexlist[sector].prevflight && this.flightsectorIndexlist[sector].prevsector == sector) {
        var depBtn = document.getElementById(`brand_btn_multi_comb${this.flightsectorIndexlist[sector].prevflight}${this.flightsectorIndexlist[sector].prevsector}${this.flightsectorIndexlist[sector].prevbrand}`) as HTMLButtonElement;
        depBtn.style.backgroundColor = "#4d4766";
        depBtn.style.color = "white";
        depBtn.textContent = "Select";
      }
    }
    catch (e) {
    }
    try {
      var depBtn = document.getElementById(`brand_btn_multi_comb${flight}${sector}${brand}`) as HTMLButtonElement;
      depBtn.style.backgroundColor = "var(--first-color-second)";
      depBtn.style.color = "black";
      depBtn.textContent = "Selected";
    }
    catch (e) {
    }
    this.displayedFlights[flight].bySectorBrands[sector].supplierPricingSolution = this.displayedFlights[flight].bySectorBrands[sector].brandsList[brand].supplierPricingSolution;
    this.displayedFlights[flight].bySectorBrands[sector].selectedbrand = this.displayedFlights[flight].bySectorBrands[sector].brandsList[brand].brandName;
    this.displayedFlights[flight].bySectorBrands[sector].brandId = this.displayedFlights[flight].bySectorBrands[sector].brandsList[brand].brandID;
    this.displayedFlights[flight].bySectorBrands[sector].priceofselectedbrand = this.displayedFlights[flight].bySectorBrands[sector].brandsList[brand].brandPrice;
    this.displayedFlights[flight].bySectorBrands[sector].passengerFares = this.displayedFlights[flight].bySectorBrands[sector].brandsList[brand].passengerFares;
    this.priceOfBrand = 0;
    for (let p = 0; p < this.displayedFlights[flight].bySectorBrands.length; p++) {
      if (this.displayedFlights[flight].bySectorBrands[p].priceofselectedbrand != undefined && this.displayedFlights[flight].bySectorBrands[p].priceofselectedbrand != null && this.displayedFlights[flight].bySectorBrands[p].priceofselectedbrand != 0) {
        this.priceOfBrand += this.displayedFlights[flight].bySectorBrands[p].priceofselectedbrand;
      }
    }
    this.flightsectorIndexlist[sector].prevbrand = brand;
    this.flightsectorIndexlist[sector].prevsector = sector;
    this.flightsectorIndexlist[sector].prevflight = flight;
  }
  ConfirmSelectBrand(index) {
    let confirmcheck = false;
    try {
      for (let sector = 0; sector < this.displayedFlights[index].bySectorBrands.length; sector++) {
        if (this.displayedFlights[index].bySectorBrands[sector].supplierPricingSolution != null && this.displayedFlights[index].bySectorBrands[sector].supplierPricingSolution != "" && this.displayedFlights[index].bySectorBrands[sector].supplierPricingSolution != undefined) {
          this.multibranderrormessage = false;
          confirmcheck = true;
        }
        else {
          this.multibranderrormessage = true;
          confirmcheck = false;
        }
      }
      if (confirmcheck) {
        this.SelectFlight(index, true);
      }

    } catch (e) {
    }
  }
  /*
------------------------------------------------------------------------------------------------------------------------------------------
-----------------------------------------------------Brands Selection Work End Here--------------------------------------------------------
------------------------------------------------------------------------------------------------------------------------------------------
*/
  /*
------------------------------------------------------------------------------------------------------------------------------------------
-----------------------------------------------------Brands Combination Selection Work End Here--------------------------------------------------------
------------------------------------------------------------------------------------------------------------------------------------------
*/

  //selectCombinationBrandFlight(flight, sector, brand) {
  //  this.multibranderrormessage = false;
  //  try {
  //    //this.flightsectorIndexlist[sector]
  //    if (flight == this.flightsectorIndexlist[sector].prevflight && this.flightsectorIndexlist[sector].prevsector == sector) {
  //      var depBtn = document.getElementById(`brand_btn_multi_comb${this.flightsectorIndexlist[sector].prevflight}${this.flightsectorIndexlist[sector].prevsector}${this.flightsectorIndexlist[sector].prevbrand}`) as HTMLButtonElement;
  //      depBtn.style.backgroundColor = "#4d4766";
  //      depBtn.style.color = "white";
  //      depBtn.textContent = "Select";
  //    }
  //  }
  //  catch (e) {
  //  }
  //  try {
  //    var depBtn = document.getElementById(`brand_btn_multi_comb${flight}${sector}${brand}`) as HTMLButtonElement;
  //    depBtn.style.backgroundColor = "var(--first-color-second)";
  //    depBtn.style.color = "black";
  //    depBtn.textContent = "Selected";
  //  }
  //  catch (e) {
  //  }
  //  this.displayedFlights[flight].bySectorBrands = [];
  //  let bysectorbrand = new BySectorBrands();
  //  bysectorbrand.supplierPricingSolution = this.displayedFlights[flight].combinationOfBrands[sector][0].supplierPricingSolution;
  //  bysectorbrand.selectedbrand = this.displayedFlights[flight].combinationOfBrands[sector][0].brandName;
  //  bysectorbrand.priceofselectedbrand = this.displayedFlights[flight].combinationOfBrands[sector][0].brandPrice;
  //  bysectorbrand.passengerFares = this.displayedFlights[flight].combinationOfBrands[sector][0].passengerFares;
  //  bysectorbrand.brandsList = [];
  //  let onewaybrand = new BrandsNew();
  //  onewaybrand = this.displayedFlights[flight].combinationOfBrands[sector][0];
  //  bysectorbrand.brandsList.push(onewaybrand);
  //  this.displayedFlights[flight].bySectorBrands.push(bysectorbrand);
  //  let returnbysectorbrand = new BySectorBrands();
  //  returnbysectorbrand.supplierPricingSolution = this.displayedFlights[flight].combinationOfBrands[sector][1].supplierPricingSolution;
  //  returnbysectorbrand.selectedbrand = this.displayedFlights[flight].combinationOfBrands[sector][1].brandName;
  //  returnbysectorbrand.priceofselectedbrand = 0;
  //  returnbysectorbrand.passengerFares = this.displayedFlights[flight].combinationOfBrands[sector][1].passengerFares;
  //  returnbysectorbrand.brandsList = [];
  //  let returnbrand = new BrandsNew();
  //  returnbrand = this.displayedFlights[flight].combinationOfBrands[sector][1];
  //  returnbysectorbrand.brandsList.push(returnbrand);
  //  this.displayedFlights[flight].bySectorBrands.push(returnbysectorbrand);
  //  this.priceOfBrand = 0;
  //  for (let p = 0; p < this.displayedFlights[flight].bySectorBrands.length; p++) {
  //    if (this.displayedFlights[flight].bySectorBrands[p].priceofselectedbrand != undefined && this.displayedFlights[flight].bySectorBrands[p].priceofselectedbrand != null && this.displayedFlights[flight].bySectorBrands[p].priceofselectedbrand != 0) {
  //      this.priceOfBrand += this.displayedFlights[flight].bySectorBrands[p].priceofselectedbrand;
  //    }
  //  }
  //  this.priceOfBrand = this.priceOfBrand * this.displayedFlights[flight].bySectorBrands[0].passengerFares[0].currencyRate;
  //  this.flightsectorIndexlist[sector].prevbrand = brand;
  //  this.flightsectorIndexlist[sector].prevsector = sector;
  //  this.flightsectorIndexlist[sector].prevflight = flight;
  //}
  ConfirmCombinationSelectBrand(index) {
    let confirmcheck = false;
    try {
      for (let sector = 0; sector < this.displayedFlights[index].bySectorBrands.length; sector++) {
        if (this.displayedFlights[index].bySectorBrands[sector].supplierPricingSolution != null && this.displayedFlights[index].bySectorBrands[sector].supplierPricingSolution != "" && this.displayedFlights[index].bySectorBrands[sector].supplierPricingSolution != undefined) {
          this.multibranderrormessage = false;
          confirmcheck = true;
        }
        else {
          this.multibranderrormessage = true;
          confirmcheck = false;
        }
      }
      if (confirmcheck) {
        this.SelectFlight(index, true);
      }

    } catch (e) {
    }
  }

  /*
------------------------------------------------------------------------------------------------------------------------------------------
-----------------------------------------------------Brands Combination Selection Work End Here--------------------------------------------------------
------------------------------------------------------------------------------------------------------------------------------------------
*/




  /*
------------------------------------------------------------------------------------------------------------------------------------------
-----------------------------------------------------Cards Price Final Work Start Here--------------------------------------------------------
------------------------------------------------------------------------------------------------------------------------------------------
*/
  toggleWithAnimationOptions(index: number) {
    this.popoverArray[index] = !this.popoverArray[index];
    let totalPrice = 0;
    ////Console.log(this.popoverArray);
    for (let i = 0; i < this.displayedFlights[index].passengerFares.length; i++) {
      totalPrice += Number(this.displayedFlights[index].passengerFares[i].agencyTotalPrice.substring(3));
    }
    this.grossPrice = this.displayedFlights[index].passengerFares[0].agencyTotalPrice.substring(0, 3) + " " + totalPrice.toFixed(2);
    ////////Console.log(this.grossPrice);
  }

  /*
------------------------------------------------------------------------------------------------------------------------------------------
-----------------------------------------------------Cards Price Final Work End Here--------------------------------------------------------
------------------------------------------------------------------------------------------------------------------------------------------
*/


  trackByFlightId(index: number, flight: FlightSchedulesNew): string {
    return flight.departureFlight.departureDate + flight.departureFlight.departure.city + flight.departureFlight.arrival.city + flight.departureFlight.departure.flightNumber + flight.departureFlight.supplier; // or unique identifier property
  }
  trackByFlightIdMulti(index: number, flight: FlightSchedulesNew): string {
    return flight.multiFlights[0].departureDate + flight.multiFlights[0].departure.city + flight.multiFlights[0].arrival.city + flight.multiFlights[0].departure.flightNumber + flight.multiFlights[0].supplier; // or unique identifier property
  }

  /*
------------------------------------------------------------------------------------------------------------------------------------------
-----------------------------------------------------Filters Selection Work Start Here--------------------------------------------------------
------------------------------------------------------------------------------------------------------------------------------------------
*/
  //airlineSmallCardfilter(filterbyAirline: FilterByAirlineProperties) {
  //  this.displayedFlights = [];
  //  let flightnewresult = JSON.parse(JSON.stringify(this.flighResultObj.flights));
  //  if (this.initialsearch != 3) {
  //    flightnewresult = flightnewresult.filter(airline =>
  //      airline.departureFlight.airlineLegalName.toLowerCase().includes(filterbyAirline.airlineName.toLowerCase())
  //    );
  //  }
  //  else {
  //    flightnewresult = flightnewresult.filter(airline =>
  //      airline.multiFlights[0].airlineLegalName.toLowerCase().includes(filterbyAirline.airlineName.toLowerCase())
  //    );
  //  }


  //  this.flightsBindList = flightnewresult;
  //  if (this.initialsearch != 3) {
  //    let sortedFlights = this.flightsBindList.sort((a, b) => Number(a.departureFlight.agencyTotalPrice.substring(3)) - Number(b.departureFlight.agencyTotalPrice.substring(3)));
  //    this.flightsBindList = sortedFlights;
  //  }
  //  else {
  //    let sortedFlights = this.flightsBindList.sort((a, b) => Number(a.multiFlights[0].agencyTotalPrice.substring(3)) - Number(b.multiFlights[0].agencyTotalPrice.substring(3)));
  //    this.flightsBindList = sortedFlights;
  //  }
  //  this.batchSize = 50;
  //  this.startIndex = 0;

  //  this.loadNextFlights();
  //}
  airlineSmallCardfilter(filterbyAirline: FilterByAirlineProperties) {

    this.displayedFlights = [];

    let flightnewresult = this.flighResultObj.flights;

    if (this.initialsearch != 3) {
      flightnewresult = flightnewresult.filter(airline =>
        airline.departureFlight.airlineLegalName
          .toLowerCase()
          .includes(filterbyAirline.airlineName.toLowerCase())
      );

      flightnewresult.sort((a, b) =>
        Number(a.departureFlight.agencyTotalPrice.substring(3)) -
        Number(b.departureFlight.agencyTotalPrice.substring(3))
      );
    }
    else {
      flightnewresult = flightnewresult.filter(airline =>
        airline.multiFlights[0].airlineLegalName
          .toLowerCase()
          .includes(filterbyAirline.airlineName.toLowerCase())
      );

      flightnewresult.sort((a, b) =>
        Number(a.multiFlights[0].agencyTotalPrice.substring(3)) -
        Number(b.multiFlights[0].agencyTotalPrice.substring(3))
      );
    }

    this.flightsBindList = flightnewresult;
    this.batchSize = 50;
    this.startIndex = 0;

    this.loadNextFlights();
  }
  //for min flight price
  getMinPrice(flights: FlightSchedulesNew[], triptype: string): number {
    if (triptype == "multi") {
      let minPrice = Math.min(...flights.map(flight => parseFloat(flight.multiFlights[0].agencyTotalPrice.slice(3))));
      return minPrice;
    }
    else {
      try {
      let minPrice = Math.min(...flights.map(flight => parseFloat(flight.departureFlight.agencyTotalPrice.slice(3))));
        return minPrice;
      }
      catch (e) {
        ////////Console.log(e);
      }
    }

  }

  //for max flight price
  getMaxPrice(flights: FlightSchedulesNew[], triptype: string): number {
    if (triptype == "multi") {
      flights = flights.filter((e): e is Exclude<typeof e, null> => e.multiFlights !== null)
      let maxPrice = Math.max(...flights.map(flight => parseFloat(flight.multiFlights[0].agencyTotalPrice.slice(3))));
      return maxPrice;
    }
    else {
      try {
        flights = flights.filter((e): e is Exclude<typeof e, null> => e.departureFlight !== null)
        let maxPrice = Math.max(...flights.map(flight => parseFloat(flight.departureFlight.agencyTotalPrice.slice(3))));
        return maxPrice;
      }
      catch (e) {
        ////////Console.log(e);
      }
    }
  }

  SliderPriceChange(changeContext) {
    if (changeContext.start != 0 && changeContext.end != 0) {
      if (!isNaN(changeContext.start) && !isNaN(changeContext.end)) {
        this.flightsBindList = this.flightresultadditionalProcessts.FlightPriceFilter(changeContext, this.flighResultObj, this.modifysearchObj);
        this.batchSize = 50;
        this.startIndex = 0;
        let sortedFlights: FlightSchedulesNew[] = [];
        if (this.oneWayResults || this.roundTripResults) {
          sortedFlights = this.flightsBindList.sort((a, b) => Number(a.departureFlight.agencyTotalPrice.substring(3)) - Number(b.departureFlight.agencyTotalPrice.substring(3)));

        }
        else if (this.multicityResults) {
          sortedFlights = this.flightsBindList.sort((a, b) => Number(a.multiFlights[0].agencyTotalPrice.substring(3)) - Number(b.multiFlights[0].agencyTotalPrice.substring(3)));

        }
        this.flightsBindList = sortedFlights;
        this.displayedFlights = [];
        this.loadNextFlights();
      }
    }
  }
  FiltersApply(event, type) {
    let multi: boolean = false;
    if (this.initialsearch == 3) {
      multi = true;
    }
    this.flightsBindList = this.flightresultadditionalProcessts.CombineFilter(event, type, multi, this.flighResultObj.flights, this.filtersBinding, this.modifysearchObj, this.flighResultObj)
    this.batchSize = 50;
    this.startIndex = 0;
    this.displayedFlights = [];
    if (this.initialsearch != 3) {
      let sortedFlights = this.flightsBindList.sort((a, b) => Number(a.departureFlight.agencyTotalPrice.substring(3)) - Number(b.departureFlight.agencyTotalPrice.substring(3)));
      this.flightsBindList = sortedFlights;
    }
    else {
      let sortedFlights = this.flightsBindList.sort((a, b) => Number(a.multiFlights[0].agencyTotalPrice.substring(3)) - Number(b.multiFlights[0].agencyTotalPrice.substring(3)));
      this.flightsBindList = sortedFlights;
    }
    this.loadNextFlights();
    if (this.displayedFlights.length === 0) {
      this.noflightavailable = true;
      this.sliderAirlineShow = false;
    } else {
      this.noflightavailable = false;
      this.sliderAirlineShow = true;
    }
  }
  loadNextFlights() {
    const endIndex = Math.min(this.startIndex + this.batchSize, this.flightsBindList.length);
    this.displayedFlights = this.displayedFlights.concat(this.flightsBindList.slice(this.startIndex, endIndex));



    this.startIndex = endIndex;


  }
  loadInitialFilters() {
    try {
    this.batchSize = 50;
    this.startIndex = 0;
    if (this.flightsBindList.length > 0) {
      //sort by lowest price
      if (this.initialsearch != 3) {
        ////////Console.log(this.flightsBindList);
        //izza let sortedFlights = this.flightsBindList.sort((a, b) => Number(a.departureFlight.agencyTotalPrice.substring(3)) - Number(b.departureFlight.agencyTotalPrice.substring(3)));
        this.flightsBindList = this.flightsBindList.filter((e): e is Exclude<typeof e, null> => e.departureFlight !== null)
        let sortedFlights = this.flightsBindList.sort((a, b) => Number(a.departureFlight.agencyTotalPrice.substring(3)) - Number(b.departureFlight.agencyTotalPrice.substring(3)));
        this.flightsBindList = sortedFlights;
        //show only some flights strategy
        this.displayedFlights = [];
       
          
          this.filtersBinding.airlinesList = this.flightresultadditionalProcessts.getAirlineFareSummaries(this.flightsBindList);
        
        //// for stop count
        const stopsDetailsList = this.flightresultadditionalProcessts.getStopsDetailsSummaries(this.flightsBindList);
        this.filtersBinding.stopsDetails.directFlights = stopsDetailsList.reduce((acc, curr) => acc + curr.directFlights, 0);
        this.filtersBinding.stopsDetails.oneStopFlights = stopsDetailsList.reduce((acc, curr) => acc + curr.oneStopFlights, 0);
        this.filtersBinding.stopsDetails.twoStopPlusFlights = stopsDetailsList.reduce((acc, curr) => acc + curr.twoStopPlusFlights, 0);
        //// for return stop count
        if (this.initialsearch === 2) {
          const ReturnstopsDetailsList = this.flightresultadditionalProcessts.getReturnStopsDetailsSummaries(this.flightsBindList);
          this.filtersBinding.stopsDetailsReturn.returnDirectFlights = ReturnstopsDetailsList.reduce((acc, curr) => acc + curr.returnDirectFlights, 0);
          this.filtersBinding.stopsDetailsReturn.returnOneStopFlights = ReturnstopsDetailsList.reduce((acc, curr) => acc + curr.returnOneStopFlights, 0);
          this.filtersBinding.stopsDetailsReturn.returnTwoStopFlights = ReturnstopsDetailsList.reduce((acc, curr) => acc + curr.returnTwoStopFlights, 0);
        }

        //// for fare type count
        const fareTypeList = this.flightresultadditionalProcessts.getFareTypeSummaries(this.flightsBindList);
        this.filtersBinding.fareType.refundableCountFlights = fareTypeList.refundableCountFlights;
        this.filtersBinding.fareType.nonRefundableCountFlights = fareTypeList.nonRefundableCountFlights;

        //this.minValueSliderFilter = this.getMinPrice(this.flightsBindList,"oneround");
        //this.maxValueSliderFilter = this.getMaxPrice(this.flightsBindList, "oneround");
        this.loadNextFlights();
      }
      else {
        let sortedFlights = this.flightsBindList.sort((a, b) => Number(a.multiFlights[0].agencyTotalPrice.substring(3)) - Number(b.multiFlights[0].agencyTotalPrice.substring(3)));
        this.flightsBindList = sortedFlights;
        //show only some flights strategy
        this.displayedFlights = [];
        this.filtersBinding.airlinesList = this.flightresultadditionalProcessts.getAirlineFareSummariesOfMulticity(this.flightsBindList);
        // for stop count
        const stopsDetailsList = this.flightresultadditionalProcessts.getStopsDetailsSummariesMul(this.flightsBindList);
        this.filtersBinding.stopsDetails.directFlights = stopsDetailsList.reduce((acc, curr) => acc + curr.directFlights, 0);
        this.filtersBinding.stopsDetails.oneStopFlights = stopsDetailsList.reduce((acc, curr) => acc + curr.oneStopFlights, 0);
        this.filtersBinding.stopsDetails.twoStopPlusFlights = stopsDetailsList.reduce((acc, curr) => acc + curr.twoStopPlusFlights, 0);

        // for fare type
        const fareTypeList = this.flightresultadditionalProcessts.getFareTypeSummariesMul(this.flightsBindList);
        this.filtersBinding.fareType.refundableCountFlights = fareTypeList.refundableCountFlights;
        this.filtersBinding.fareType.nonRefundableCountFlights = fareTypeList.nonRefundableCountFlights;

        //this.minValueSliderFilter = this.getMinPrice(this.flightsBindList,"multi");
        //this.maxValueSliderFilter = this.getMaxPrice(this.flightsBindList, "multi");
        this.loadNextFlights();
      }


      }
    }
    catch (ee) {
      ////////Console.log(ee);
    }
  }

  clearFilter() {
    this.batchSize = 50;
    this.startIndex = 0;
    this.displayedFlights = [];
    this.filtersBinding.airlinesList = [];
    this.filtersBinding.fareType = new FaretypeFilters();
    this.filtersBinding.timeList = new TimeListFilter();
    this.filtersBinding.stopsDetails = new StopFlightFilters();
    this.filtersBinding.stopsDetailsReturn = new StopFlightFilters();
    this.flightsBindList = this.flighResultObj.flights;
    this.loadInitialFilters();
  }
  applyMarkUPClick() {
    if (this.filtersBinding.applyMarkup > 0) {
      this.filtersBinding.markupIsChecked = true;
    }
    //* airSeg.length
    if (this.initialsearch == 3 && this.filtersBinding.applyMarkup > 0) {
      for (let i = 0; i < this.flightsBindList.length; i++) {
        let currency: string = this.flightsBindList[i].passengerFares[0].agencyTotalPrice.substring(0, 3);
        let airSeg: AirSegmentsDetailsNew[] = [];
        airSeg = this.flightsBindList[i].airSegmentsNew;
        let totalPassenger = this.sentToBacksearchObj.child + this.sentToBacksearchObj.adult + this.sentToBacksearchObj.infant;
        let addedmarkup = (this.filtersBinding.applyMarkup * totalPassenger) - (this.previousmarkup * totalPassenger);
        // this.totalMarkupPerPassenger = this.markup ;
        let taxAmount: number;
        taxAmount = Number(this.flightsBindList[i].multiFlights[0].agencyTaxAmount.substring(3));
        taxAmount += addedmarkup;
        taxAmount = Number(taxAmount.toFixed(2));
        this.flightsBindList[i].multiFlights[0].totalTaxAmount = currency + taxAmount;
        let totalAmount = Number(this.flightsBindList[i].multiFlights[0].agencyTotalPrice.substring(3));
        totalAmount += addedmarkup;
        //totalAmount += taxAmount;
        this.flightsBindList[i].multiFlights[0].agencyTotalPrice = currency + totalAmount;
        for (let k = 0; k < this.flightsBindList[i].passengerFares.length; k++) {
          let addedmarkup = (this.filtersBinding.applyMarkup * this.flightsBindList[i].passengerFares[k].count) - (this.previousmarkup * this.flightsBindList[i].passengerFares[k].count);
          taxAmount = Number(this.flightsBindList[i].passengerFares[k].agencyTaxAmount.split(currency)[1]);
          taxAmount += addedmarkup;
          this.flightsBindList[i].passengerFares[k].agencyTaxAmount = currency + taxAmount;
          totalAmount = Number(this.flightsBindList[i].passengerFares[k].agencyTotalPrice.split(currency)[1]);
          totalAmount += addedmarkup;
          totalAmount = Number(totalAmount.toFixed(2));
          this.flightsBindList[i].passengerFares[k].agencyTotalPrice = currency + totalAmount;
        }
      }
      this.batchSize = 50;
      this.startIndex = 0;
      this.displayedFlights = [];
      this.loadNextFlights();
      this.previousmarkup = this.filtersBinding.applyMarkup;
    }
    else if (this.filtersBinding.applyMarkup > 0) {
      for (let i = 0; i < this.flightsBindList.length; i++) {
        let currency: string = this.flightsBindList[i].passengerFares[0].agencyTotalPrice.substring(0, 3);
        let airSeg: AirSegmentsDetailsNew[] = [];
        airSeg = this.flightsBindList[i].airSegmentsNew;
        let totalPassenger = this.sentToBacksearchObj.child + this.sentToBacksearchObj.adult + this.sentToBacksearchObj.infant;
        let addedmarkup = (this.filtersBinding.applyMarkup * totalPassenger) - (this.previousmarkup * totalPassenger);
        // this.totalMarkupPerPassenger = this.markup ;
        let taxAmount: number;
        taxAmount = Number(this.flightsBindList[i].departureFlight.agencyTaxAmount.substring(3));
        taxAmount += addedmarkup;
        taxAmount = Number(taxAmount.toFixed(2));
        this.flightsBindList[i].departureFlight.totalTaxAmount = currency + taxAmount;
        let totalAmount = Number(this.flightsBindList[i].departureFlight.agencyTotalPrice.split(currency)[1]);
        totalAmount += addedmarkup;
        totalAmount = Number(totalAmount.toFixed(2));
        //totalAmount += taxAmount;
        this.flightsBindList[i].departureFlight.agencyTotalPrice = currency + totalAmount;
        for (let k = 0; k < this.flightsBindList[i].passengerFares.length; k++) {
          let addedmarkup = (this.filtersBinding.applyMarkup * this.flightsBindList[i].passengerFares[k].count) - (this.previousmarkup * this.flightsBindList[i].passengerFares[k].count);
          taxAmount = Number(this.flightsBindList[i].passengerFares[k].agencyTaxAmount.split(currency)[1]);
          taxAmount += addedmarkup;
          taxAmount = Number(taxAmount.toFixed(2));
          this.flightsBindList[i].passengerFares[k].agencyTaxAmount = currency + taxAmount;
          totalAmount = Number(this.flightsBindList[i].passengerFares[k].agencyTotalPrice.split(currency)[1]);
          totalAmount += addedmarkup;
          totalAmount = Number(totalAmount.toFixed(2));
          this.flightsBindList[i].passengerFares[k].agencyTotalPrice = currency + totalAmount;
        }
      }
      this.batchSize = 50;
      this.startIndex = 0;
      this.displayedFlights = [];
      this.loadNextFlights();
      this.previousmarkup = this.filtersBinding.applyMarkup;
    }
  }
  /*
------------------------------------------------------------------------------------------------------------------------------------------
-----------------------------------------------------Filters Selection Work End Here--------------------------------------------------------
------------------------------------------------------------------------------------------------------------------------------------------
*/



  /*
------------------------------------------------------------------------------------------------------------------------------------------
-----------------------------------------------------Group Ticket Start Here--------------------------------------------------------
------------------------------------------------------------------------------------------------------------------------------------------
*/



  /*
------------------------------------------------------------------------------------------------------------------------------------------
-----------------------------------------------------Group Ticket END Here--------------------------------------------------------
------------------------------------------------------------------------------------------------------------------------------------------
*/


  /*
------------------------------------------------------------------------------------------------------------------------------------------
-----------------------------------------------------Change RBD  END Here--------------------------------------------------------
------------------------------------------------------------------------------------------------------------------------------------------
*/
  revalidateflightavailable: boolean = false;
  SelectRBDSector(index: number) {
    this.flightsBeforeLoad = true;
    this.rbdflightData.flights = [];
    let params = new ChangeRBDParamsGalileo();
    this.searchObj.parentHierarchy = localStorage.getItem("ParentHierarchy");
    params.flightSearch = this.sentToBacksearchObj;
    let spCode = this.displayedFlights[index].airSegmentsNew;
    params.supplier = this.displayedFlights[index].departureFlight.supplier;
    params.bookingPCC = this.displayedFlights[index].departureFlight.pcc;
    params.flightScheduleNew = this.displayedFlights[index];
    this.flightService.InitialBook(params).subscribe((data) => {
      this.flightsBeforeLoad = false;
      if (data.flights.length == 0) {
        this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'These selected RBDs are not bookable.' });
      }
      if (data.flights.length > 0) {
        this.revalidateflightavailable = true;
        this.rbdflightData = data;
        let rbdCharges = [];
        let penaltyC = [];
        this.grossTotal = 0;
        let baggage = [];
        if (this.rbdflightData.flights[0].departureFlight.supplier != "mm") {
          for (let n = 0; n < this.rbdflightData.flights.length; n++) {
            for (let m = 0; m < this.rbdflightData.flights[n].frontBaggageAllowance.length; m++) {
              baggage[m] = {
                sector: this.rbdflightData.flights[n].frontBaggageAllowance[m].sector ? this.rbdflightData.flights[n].frontBaggageAllowance[m].sector :
                  this.rbdflightData.flights[n].airSegmentsNew[m].origin.code + '--' + this.rbdflightData.flights[n].airSegmentsNew[m].destination.code,
                baggageDet: this.rbdflightData.flights[n].frontBaggageAllowance[m].checkinBaggage ? this.rbdflightData.flights[n].frontBaggageAllowance[m].checkinBaggage : "",
                desc2: this.rbdflightData.flights[n].frontBaggageAllowance[m].cabinBaggage ? this.rbdflightData.flights[n].frontBaggageAllowance[m].cabinBaggage : ""
              }
            }
          }
          this.rbdBaggage = baggage;

          for (let p = 0; p < this.rbdflightData.flights.length; p++) {
            for (let q = 0; q < this.rbdflightData.flights[p].passengerFares.length; q++) {
              let paxType: string = "";
              let cancel: string = "";
              let change: string = "";
              // if (this.rbdflightData.flights[p].passengerFares[q].passengerType != null &&
              //   this.rbdflightData.flights[p].passengerFares[q].passengerType != undefined)
              //   this.rbdflightData.flights[p].passengerFares[q].passengerType + "(" + this.rbdflightData.flights[p].passengerFares[q].count + ")";
              // if (this.rbdflightData.flights[p].AirPricingSolution.airPricingInfo[q].cancelPenalty != null &&
              //   this.rbdflightData.flights[p].airPricingSolution.airPricingInfo[q].cancelPenalty != undefined)
              //   cancel = this.rbdflightData.flights[p].airPricingSolution.airPricingInfo[q].cancelPenalty[0].amount ? this.rbdflightData.flights[p].airPricingSolution.airPricingInfo[q].cancelPenalty[0].amount : 0;
              // if (this.rbdflightData.flights[p].airPricingSolution.airPricingInfo[q].changePenalty != null &&
              //   this.rbdflightData.flights[p].airPricingSolution.airPricingInfo[q].changePenalty != undefined)
              //   change = this.rbdflightData.flights[p].airPricingSolution.airPricingInfo[q].changePenalty[0].amount ? this.rbdflightData.flights[p].airPricingSolution.airPricingInfo[q].changePenalty[0].amount : 0
              penaltyC[q] = {
                paxType,
                cancel,
                change
              }
              this.penaltyCharge = penaltyC;
            }
          }
          for (let p = 0; p < this.rbdflightData.flights.length; p++) {
            for (let q = 0; q < this.rbdflightData.flights[p].passengerFares.length; q++) {
              rbdCharges[q] = {
                paxType: this.rbdflightData.flights[p].passengerFares[q].passengerType + "(" + this.rbdflightData.flights[p].passengerFares[q].count + ")",
                basePrice: this.rbdflightData.flights[p].passengerFares[q].agencyBaseFareAmount,
                taxes: this.rbdflightData.flights[p].passengerFares[q].agencyTaxAmount,
                serviceCharges: this.rbdflightData.flights[p].passengerFares[q].agencyServiceFee,
                discount: this.rbdflightData.flights[p].passengerFares[q].agencyDiscount,
                total: this.rbdflightData.flights[p].passengerFares[q].agencyTotalPrice,
              }
              this.grossTotal = this.grossTotal + Number(this.rbdflightData.flights[p].passengerFares[q].agencyTotalPrice.slice(3)) *
                this.rbdflightData.flights[p].passengerFares[q].count;
            }
          }
          for (let cd = 0; cd < rbdCharges.length; cd++) {
            if (rbdCharges[cd].paxType.slice(0, 1) == "1") {
              rbdCharges[cd].paxType = "ADT" + rbdCharges[cd].paxType.slice(1);
            }
            if (rbdCharges[cd].paxType.slice(0, 1) == "2") {
              rbdCharges[cd].paxType = "CHD" + rbdCharges[cd].paxType.slice(1);
            }
            if (rbdCharges[cd].paxType.slice(0, 1) == "3") {
              rbdCharges[cd].paxType = "INF" + rbdCharges[cd].paxType.slice(1);
            }
          }
          this.rbdCharg = rbdCharges;
        }
      }
    });
  }

  onChangeBookingPopupHiding(index: number) {
    if (this.displayedFlights[index] != null && this.displayedFlights[index].rbdSegments != null) {
      this.displayedFlights[index].rbdSegments.forEach(rs => {
        if (rs != null) {
          rs.selectedRBD = "";
        }
      });
    }
  }


  SelectRbdFlight() {
    try {
      if (this.rbdflightData != null) {
        if (this.rbdflightData.flights.length > 0) {
          let requestObj = new BookingBasicProperties();
          requestObj.extraProfit = this.filtersBinding.applyMarkup;
          requestObj.brandsSelected = false;
          requestObj.fromAirport = this.rbdflightData.flights[0].fromAirport;
          requestObj.toAirport = this.rbdflightData.flights[0].toAirport;
          requestObj.airportsList = this.airportList;
          requestObj.bookingPCC = this.rbdflightData.flights[0].departureFlight.pcc;
          requestObj.airSegment = this.rbdflightData.flights[0].airSegmentsNew;
          requestObj.flightProp = this.searchObj;
          requestObj.stopcount = this.rbdflightData.flights[0].departureFlight.stopCount;
          requestObj.supplierCode = this.rbdflightData.flights[0].departureFlight.supplier;
          requestObj.passengerFares = this.rbdflightData.flights[0].passengerFares;
          requestObj.nonRefundable = this.rbdflightData.flights[0].departureFlight.nonRefundable;
          requestObj.supplierPricingSolution = this.rbdflightData.flights[0].supplierPricingSolution;
          requestObj.transactionIdentifierJ = this.rbdflightData.flights[0].transactionIdentifier;
          requestObj.flightscheduleNew = this.rbdflightData.flights[0];
          this.GetTimeAgainstSupplier(this.rbdflightData.flights[0].departureFlight.supplier);
          sessionStorage.setItem('bkdata', JSON.stringify(requestObj));
          this.router.navigateByUrl('/passengerInfo');
        }
        else {


        }
      }
    }
    catch (e) {
    }
  }
  /*
------------------------------------------------------------------------------------------------------------------------------------------
-----------------------------------------------------Change RBD END Here--------------------------------------------------------
------------------------------------------------------------------------------------------------------------------------------------------
*/


  GetTimeAgainstSupplier(supplier) {
    let time = "";
    if (supplier == "G9" || supplier == "3L" || supplier == "9P" || supplier == "ONEAPI") {
      if ((this.sentToBacksearchObj.adult + this.sentToBacksearchObj.child + this.sentToBacksearchObj.infant) == 1) {
        this.bookingTimerService.setTime(10);
      }
      else {
        this.bookingTimerService.setTime(15);
      }

    }
    else if (supplier == "1G" || supplier == "6E") {
      this.bookingTimerService.setTime(30);
    }
    else if (supplier == "AI" || supplier == "SG" || supplier == "J9") {
      this.bookingTimerService.setTime(14);
    }
    else if (supplier == "BS") {
      this.bookingTimerService.setTime(20);
    }
    else {
      this.bookingTimerService.setTime(15);
    }
  }

  BrandsFareRules(indexflight: number, bysect: number, indexbrand: number) {
    if (this.oneWayResults || this.roundTripResults) {
      if (this.displayedFlights[indexflight].fareRulesAfterShowAvailiable &&
        (this.displayedFlights[indexflight].departureFlight.supplier == "AI" || this.displayedFlights[indexflight].departureFlight.supplier == "J9" || this.displayedFlights[indexflight].departureFlight.supplier == "1GNDC" || this.displayedFlights[indexflight].departureFlight.supplier == "1GGDS" || this.displayedFlights[indexflight].departureFlight.supplier == "FZ")) {
        this.OneWayReturnBrandsFareRules(indexflight, bysect, indexbrand);

      }
      else if (this.multicityResults && this.displayedFlights[indexflight].multiFlights[0].supplier == "FZ") {
        this.OnewayReturnFareRules(indexflight);
      }

      else {
        this.brandFareRulesObj = new FareRulesNew();
        if (this.displayedFlights[indexflight].bySectorBrands[bysect].brandsList[indexbrand].fareRules != null &&
          this.displayedFlights[indexflight].bySectorBrands[bysect].brandsList[indexbrand].fareRules != undefined) {
          this.brandFareRulesObj = this.displayedFlights[indexflight].bySectorBrands[bysect].brandsList[indexbrand].fareRules;
          this.farerulesopenbrandView = true;
        }
        else {
          this.messageService.add({ severity: 'error', summary: 'FareRules', detail: 'Not Available!' });

        }
      }
    }
    else {
      if (this.displayedFlights[indexflight].fareRulesAfterShowAvailiable &&
        (this.displayedFlights[indexflight].multiFlights[0].supplier == "1GNDC" || this.displayedFlights[indexflight].multiFlights[0].supplier == "1GGDS")) {
        this.OneWayReturnBrandsFareRules(indexflight, bysect, indexbrand);

      }
      else {
        this.brandFareRulesObj = new FareRulesNew();
        if (this.displayedFlights[indexflight].bySectorBrands[bysect].brandsList[indexbrand].fareRules != null &&
          this.displayedFlights[indexflight].bySectorBrands[bysect].brandsList[indexbrand].fareRules != undefined) {
          this.brandFareRulesObj = this.displayedFlights[indexflight].bySectorBrands[bysect].brandsList[indexbrand].fareRules;
          this.farerulesopenbrandView = true;
        }
        else {
          this.messageService.add({ severity: 'error', summary: 'FareRules', detail: 'Not Available!' });

        }
      }
    }



  }
  //OneWayReturnBrandsFareRules(flightIndex: number, bysect: number, indexbrand: number) {
  //  let gal = new ChangeRBDParamsGalileo();
  //  gal.brandselected = false;
  //  this.flightsBeforeLoad = true;
  //  if (this.oneWayResults == true || this.roundTripResults == true) {
  //    gal.flightSearch = this.sentToBacksearchObj;
  //    gal.flightScheduleNew = this.displayedFlights[flightIndex];
  //    gal.supplier = this.displayedFlights[flightIndex].departureFlight.supplier;
  //    gal.bookingPCC = this.displayedFlights[flightIndex].departureFlight.pcc;
  //    gal.brandselected = true;
  //    gal.fromAirport = this.displayedFlights[flightIndex].bySectorBrands[bysect].fromAirport;
  //    gal.toAirport = this.displayedFlights[flightIndex].bySectorBrands[bysect].toAirport;
  //    gal.transactionIdentifier = this.displayedFlights[flightIndex].transactionIdentifier;
  //    gal.supplierpricingSolution = this.displayedFlights[flightIndex].bySectorBrands[bysect].brandsList[indexbrand].supplierPricingSolution;
  //    gal.passengerFares = this.displayedFlights[flightIndex].bySectorBrands[bysect].brandsList[indexbrand].passengerFares;

  //    this.flightService.GetFlightFareRules(gal).subscribe((data) => {
  //      this.flightsBeforeLoad = false;
  //      if (data != null && data.flights != null && data.flights.length > 0) {
  //        this.displayedFlights[flightIndex].bySectorBrands[bysect].brandsList[indexbrand].fareRules = data.flights[0].fareRulesNew;
  //        this.brandFareRulesObj = new FareRulesNew();
  //        if (this.displayedFlights[flightIndex].bySectorBrands[bysect].brandsList[indexbrand].fareRules != null &&
  //          this.displayedFlights[flightIndex].bySectorBrands[bysect].brandsList[indexbrand].fareRules != undefined) {
  //          this.brandFareRulesObj = this.displayedFlights[flightIndex].bySectorBrands[bysect].brandsList[indexbrand].fareRules;
  //          this.brandFareRulesObj.supplier = this.displayedFlights[flightIndex].departureFlight.supplier;
  //          this.farerulesopenbrandView = true;
  //        }
  //        else {
  //          this.messageService.add({ severity: 'error', summary: 'FareRules', detail: 'Not Available!' });

  //        }

  //      }
  //    });



  //  }
  //  else if (this.multicityResults) {
  //    gal.flightSearch = this.sentToBacksearchObj;
  //    gal.flightScheduleNew = this.displayedFlights[flightIndex];
  //    gal.supplier = this.displayedFlights[flightIndex].multiFlights[0].supplier;
  //    gal.bookingPCC = this.displayedFlights[flightIndex].multiFlights[0].pcc;
  //    gal.brandselected = true;
  //    gal.fromAirport = this.displayedFlights[flightIndex].bySectorBrands[bysect].fromAirport;
  //    gal.toAirport = this.displayedFlights[flightIndex].bySectorBrands[bysect].toAirport;
  //    gal.transactionIdentifier = this.displayedFlights[flightIndex].transactionIdentifier;
  //    gal.supplierpricingSolution = this.displayedFlights[flightIndex].bySectorBrands[bysect].brandsList[indexbrand].supplierPricingSolution;
  //    gal.passengerFares = this.displayedFlights[flightIndex].bySectorBrands[bysect].brandsList[indexbrand].passengerFares;

  //    this.flightService.GetFlightFareRules(gal).subscribe((data) => {
  //      this.flightsBeforeLoad = false;
  //      if (data != null && data.flights != null && data.flights.length > 0) {
  //        this.displayedFlights[flightIndex].bySectorBrands[bysect].brandsList[indexbrand].fareRules = data.flights[0].fareRulesNew;
  //        this.brandFareRulesObj = new FareRulesNew();
  //        if (this.displayedFlights[flightIndex].bySectorBrands[bysect].brandsList[indexbrand].fareRules != null &&
  //          this.displayedFlights[flightIndex].bySectorBrands[bysect].brandsList[indexbrand].fareRules != undefined) {
  //          this.brandFareRulesObj = this.displayedFlights[flightIndex].bySectorBrands[bysect].brandsList[indexbrand].fareRules;
  //          this.brandFareRulesObj.supplier = this.displayedFlights[flightIndex].multiFlights[0].supplier;
  //          this.farerulesopenbrandView = true;
  //        }
  //        else {
  //          this.messageService.add({ severity: 'error', summary: 'FareRules', detail: 'Not Available!' });

  //        }

  //      }
  //    });
  //  }
  //}
  closethefarechanged(index: number) {
    this.fareChanged = new FareChangedProperties();
    this.fareChangedPopUp[index] = false;
    this.brandsChanged = false;
    this.isFareChanged = false;
  }

  checkConnection() {
    if (!navigator.onLine) {
      this.isOffline = true;
    } else {
      this.isOffline = false;
    }
  }


  selectCombinationBrandFlight(flight, sector, brand) {
    this.multibranderrormessage = false;
    try {
      //this.flightsectorIndexlist[sector]
      if (flight == this.flightsectorIndexlist[sector].prevflight && this.flightsectorIndexlist[sector].prevsector == sector) {
        var depBtn = document.getElementById(`brand_btn_multi_comb${this.flightsectorIndexlist[sector].prevflight}${this.flightsectorIndexlist[sector].prevsector}${this.flightsectorIndexlist[sector].prevbrand}`) as HTMLButtonElement;
        depBtn.style.backgroundColor = "#4d4766";
        depBtn.style.color = "white";
        depBtn.textContent = "Select";
      }
    }
    catch (e) {
    }
    try {
      var depBtn = document.getElementById(`brand_btn_multi_comb${flight}${sector}${brand}`) as HTMLButtonElement;
      depBtn.style.backgroundColor = "var(--first-color-second)";
      depBtn.style.color = "black";
      depBtn.textContent = "Selected";
    }
    catch (e) {
    }
    this.displayedFlights[flight].bySectorBrands = [];
    if (this.sentToBacksearchObj.tripType != "multi") {
      if (this.displayedFlights[flight].departureFlight.supplier == "1GGDS" ||
        this.displayedFlights[flight].departureFlight.supplier == "1GNDC") {
        let bysectorbrand = new BySectorBrands();
        bysectorbrand.supplierPricingSolution = this.displayedFlights[flight].combinationOfBrands[sector][0].supplierPricingSolution;
        bysectorbrand.selectedbrand = this.displayedFlights[flight].combinationOfBrands[sector][0].brandID.toString();
        bysectorbrand.priceofselectedbrand = this.displayedFlights[flight].combinationOfBrands[sector][0].brandPrice;
        bysectorbrand.passengerFares = this.displayedFlights[flight].combinationOfBrands[sector][0].passengerFares;
        bysectorbrand.brandsList = [];
        bysectorbrand.brandsList = this.displayedFlights[flight].combinationOfBrands[sector];
        this.displayedFlights[flight].bySectorBrands.push(bysectorbrand);
        this.displayedFlights[flight].combinationOfBrands[sector][0].brandID
      }
      else {
        let bysectorbrand = new BySectorBrands();
        bysectorbrand.supplierPricingSolution = this.displayedFlights[flight].combinationOfBrands[sector][0].supplierPricingSolution;
        bysectorbrand.selectedbrand = this.displayedFlights[flight].combinationOfBrands[sector][0].brandName;
        bysectorbrand.priceofselectedbrand = this.displayedFlights[flight].combinationOfBrands[sector][0].brandPrice;
        bysectorbrand.passengerFares = this.displayedFlights[flight].combinationOfBrands[sector][0].passengerFares;
        bysectorbrand.brandsList = [];
        let onewaybrand = new BrandsNew();
        onewaybrand = this.displayedFlights[flight].combinationOfBrands[sector][0];
        bysectorbrand.brandsList.push(onewaybrand);
        this.displayedFlights[flight].bySectorBrands.push(bysectorbrand);
        let returnbysectorbrand = new BySectorBrands();
        returnbysectorbrand.supplierPricingSolution = this.displayedFlights[flight].combinationOfBrands[sector][1].supplierPricingSolution;
        returnbysectorbrand.selectedbrand = this.displayedFlights[flight].combinationOfBrands[sector][1].brandName;
        returnbysectorbrand.priceofselectedbrand = 0;
        returnbysectorbrand.passengerFares = this.displayedFlights[flight].combinationOfBrands[sector][1].passengerFares;
        returnbysectorbrand.brandsList = [];
        let returnbrand = new BrandsNew();
        returnbrand = this.displayedFlights[flight].combinationOfBrands[sector][1];
        returnbysectorbrand.brandsList.push(returnbrand);
        this.displayedFlights[flight].bySectorBrands.push(returnbysectorbrand);
      }
    }
    else {
      if (this.displayedFlights[flight].multiFlights[0].supplier == "1GGDS" ||
        this.displayedFlights[flight].multiFlights[0].supplier == "1GNDC") {
        let bysectorbrand = new BySectorBrands();
        bysectorbrand.supplierPricingSolution = this.displayedFlights[flight].combinationOfBrands[sector][0].supplierPricingSolution;
        bysectorbrand.selectedbrand = this.displayedFlights[flight].combinationOfBrands[sector][0].brandID.toString();
        bysectorbrand.priceofselectedbrand = this.displayedFlights[flight].combinationOfBrands[sector][0].brandPrice;
        bysectorbrand.passengerFares = this.displayedFlights[flight].combinationOfBrands[sector][0].passengerFares;
        bysectorbrand.brandsList = [];
        bysectorbrand.brandsList = this.displayedFlights[flight].combinationOfBrands[sector];
        this.displayedFlights[flight].bySectorBrands.push(bysectorbrand);
      }
    }


    this.priceOfBrand = 0;
    for (let p = 0; p < this.displayedFlights[flight].bySectorBrands.length; p++) {
      if (this.displayedFlights[flight].bySectorBrands[p].priceofselectedbrand != undefined && this.displayedFlights[flight].bySectorBrands[p].priceofselectedbrand != null && this.displayedFlights[flight].bySectorBrands[p].priceofselectedbrand != 0) {
        this.priceOfBrand += this.displayedFlights[flight].bySectorBrands[p].priceofselectedbrand;
      }
    }
    this.priceOfBrand = this.priceOfBrand * this.displayedFlights[flight].bySectorBrands[0].passengerFares[0].currencyRate;
    this.flightsectorIndexlist[sector].prevbrand = brand;
    this.flightsectorIndexlist[sector].prevsector = sector;
    this.flightsectorIndexlist[sector].prevflight = flight;
  }




  OneWayReturnBrandsFareRules(flightIndex: number, bysect: number, indexbrand: number) {
    let gal = new ChangeRBDParamsGalileo();
    gal.brandselected = false;
    this.flightsBeforeLoad = true;
    if (this.oneWayResults == true || this.roundTripResults == true) {
      gal.flightSearch = this.sentToBacksearchObj;
      gal.flightScheduleNew = this.displayedFlights[flightIndex];
      gal.supplier = this.displayedFlights[flightIndex].departureFlight.supplier;
      gal.bookingPCC = this.displayedFlights[flightIndex].departureFlight.pcc;
      gal.brandselected = true;
      if (!this.displayedFlights[flightIndex].combinationBrandsAvailiable) {
        gal.fromAirport = this.displayedFlights[flightIndex].bySectorBrands[bysect].fromAirport;
        gal.toAirport = this.displayedFlights[flightIndex].bySectorBrands[bysect].toAirport;
        gal.supplierpricingSolution = this.displayedFlights[flightIndex].bySectorBrands[bysect].brandsList[indexbrand].supplierPricingSolution;
        gal.passengerFares = this.displayedFlights[flightIndex].bySectorBrands[bysect].brandsList[indexbrand].passengerFares;
      }
      else {
        gal.supplierpricingSolution = this.displayedFlights[flightIndex].combinationOfBrands[bysect][indexbrand].supplierPricingSolution;
        gal.passengerFares = this.displayedFlights[flightIndex].combinationOfBrands[bysect][indexbrand].passengerFares;
        gal.fromAirport = this.displayedFlights[flightIndex].fromAirport;
        gal.toAirport = this.displayedFlights[flightIndex].toAirport;
      }

      gal.transactionIdentifier = this.displayedFlights[flightIndex].transactionIdentifier;


      this.flightService.GetFlightFareRules(gal).subscribe((data) => {
        this.flightsBeforeLoad = false;
        if (data != null && data.flights != null && data.flights.length > 0) {
          if (!this.displayedFlights[flightIndex].combinationBrandsAvailiable) {
            this.displayedFlights[flightIndex].bySectorBrands[bysect].brandsList[indexbrand].fareRules = data.flights[0].fareRulesNew;
            this.brandFareRulesObj = new FareRulesNew();
            if (this.displayedFlights[flightIndex].bySectorBrands[bysect].brandsList[indexbrand].fareRules != null &&
              this.displayedFlights[flightIndex].bySectorBrands[bysect].brandsList[indexbrand].fareRules != undefined) {
              this.brandFareRulesObj = this.displayedFlights[flightIndex].bySectorBrands[bysect].brandsList[indexbrand].fareRules;
              this.brandFareRulesObj.supplier = this.displayedFlights[flightIndex].departureFlight.supplier;
              this.farerulesopenbrandView = true;
            }
            else {
              this.messageService.add({ severity: 'error', summary: 'FareRules', detail: 'Not Available!' });

            }
          }
          else {
            this.brandFareRulesObj = new FareRulesNew();
            if (data.flights[0].fareRulesNew != null &&
              data.flights[0].fareRulesNew != undefined) {
              this.brandFareRulesObj = data.flights[0].fareRulesNew;
              this.brandFareRulesObj.supplier = this.displayedFlights[flightIndex].departureFlight.supplier;
              this.farerulesopenbrandView = true;
            }
            else {
              this.messageService.add({ severity: 'error', summary: 'FareRules', detail: 'Not Available!' });

            }
          }

        }
      });



    }
    else if (this.multicityResults) {
      gal.flightSearch = this.sentToBacksearchObj;
      gal.flightScheduleNew = this.displayedFlights[flightIndex];
      gal.supplier = this.displayedFlights[flightIndex].multiFlights[0].supplier;
      gal.bookingPCC = this.displayedFlights[flightIndex].multiFlights[0].pcc;
      gal.brandselected = true;
      if (!this.displayedFlights[flightIndex].combinationBrandsAvailiable) {
        gal.fromAirport = this.displayedFlights[flightIndex].bySectorBrands[bysect].fromAirport;
        gal.toAirport = this.displayedFlights[flightIndex].bySectorBrands[bysect].toAirport;
        gal.supplierpricingSolution = this.displayedFlights[flightIndex].bySectorBrands[bysect].brandsList[indexbrand].supplierPricingSolution;
        gal.passengerFares = this.displayedFlights[flightIndex].bySectorBrands[bysect].brandsList[indexbrand].passengerFares;
      }
      else {
        gal.fromAirport = this.displayedFlights[flightIndex].fromAirport;
        gal.toAirport = this.displayedFlights[flightIndex].toAirport;
        gal.supplierpricingSolution = this.displayedFlights[flightIndex].combinationOfBrands[bysect][indexbrand].supplierPricingSolution;
        gal.passengerFares = this.displayedFlights[flightIndex].combinationOfBrands[bysect][indexbrand].passengerFares;
      }
      gal.transactionIdentifier = this.displayedFlights[flightIndex].transactionIdentifier;

      this.flightService.GetFlightFareRules(gal).subscribe((data) => {
        this.flightsBeforeLoad = false;
        if (data != null && data.flights != null && data.flights.length > 0) {
          if (!this.displayedFlights[flightIndex].combinationBrandsAvailiable) {


            this.displayedFlights[flightIndex].bySectorBrands[bysect].brandsList[indexbrand].fareRules = data.flights[0].fareRulesNew;
            this.brandFareRulesObj = new FareRulesNew();
            if (this.displayedFlights[flightIndex].bySectorBrands[bysect].brandsList[indexbrand].fareRules != null &&
              this.displayedFlights[flightIndex].bySectorBrands[bysect].brandsList[indexbrand].fareRules != undefined) {
              this.brandFareRulesObj = this.displayedFlights[flightIndex].bySectorBrands[bysect].brandsList[indexbrand].fareRules;
              this.brandFareRulesObj.supplier = this.displayedFlights[flightIndex].multiFlights[0].supplier;
              this.farerulesopenbrandView = true;
            }
            else {
              this.messageService.add({ severity: 'error', summary: 'FareRules', detail: 'Not Available!' });

            }
          }
          else {
            this.brandFareRulesObj = new FareRulesNew();
            if (data.flights[0].fareRulesNew != null &&
              data.flights[0].fareRulesNew != undefined) {
              this.brandFareRulesObj = data.flights[0].fareRulesNew;
              this.brandFareRulesObj.supplier = this.displayedFlights[flightIndex].multiFlights[0].supplier;
              this.farerulesopenbrandView = true;
            }
            else {
              this.messageService.add({ severity: 'error', summary: 'FareRules', detail: 'Not Available!' });

            }
          }

        }
      });
    }
  }

}



